/**
 * Created by rastwe on 3/1/2017.
 */
export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR';

export const API_ERRORS = 'API_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const SET_IS_GLOBAL_ERROR_TOAST_HIDDEN = 'SET_IS_GLOBAL_ERROR_TOAST_HIDDEN';
export const SUCCESS_MESSAGE = 'SUCCESS_MESSAGE';
export const WARNING_MESSAGE = 'WARNING_MESSAGE';
export const INFO_MESSAGE = 'INFO_MESSAGE';

export const GET_ALL_TASKS = 'GET_ALL_TASKS';
export const GET_ALL_TASKS_PREPARER_COUNT = 'GET_ALL_TASKS_PREPARER_COUNT';
export const GET_ALL_TASKS_FOR_WCGW = 'GET_ALL_TASKS_FOR_WCGW';
export const GET_ALL_BUILD_TASKS = 'GET_ALL_BUILD_TASKS';
export const GET_ALL_TASKS_SERVICE_REQUEST = 'GET_ALL_TASKS_SERVICE_REQUEST';
export const GET_ALL_SUGGESTED_TASKS = 'GET_ALL_SUGGESTED_TASKS';
export const GET_ALL_TASKS_METRICS = 'GET_ALL_TASKS_METRICS';
export const GET_ALL_TASKS_UNASSIGNED = 'GET_ALL_TASKS_UNASSIGNED';
export const RESET_TASKS_UNASSIGNED = 'RESET_TASKS_UNASSIGNED';
export const REJECT_TASK = 'REJECT_TASK';
export const ACCEPT_TASK = 'ACCEPT_TASK';
export const REMOVE_TASK = 'REMOVE_TASK';

export const UPDATE_COMPLETED_TASK = 'UPDATE_COMPLETED_TASK';
export const GET_IS_TASKS_GROUP = 'GET_IS_TASKS_GROUP';
export const GET_TASK_DETAILS = 'GET_TASK_DETAILS';
export const GET_TASK_TAGS = 'GET_TASK_TAGS';
export const GET_ALL_TASK_SECTIONS = 'GET_ALL_TASK_SECTIONS';
export const REFRESH_TASK_IN_TASK_SECTIONS = 'REFRESH_TASK_IN_TASK_SECTIONS';
export const DELETE_TASKSECTION_BY_ID = 'DELETE_TASKSECTION_BY_ID';
export const CREATE_TASK_SECTION = 'CREATE_TASK_SECTION';
export const GET_TASK_SECTION_BY_ID = 'GET_TASK_SECTION_BY_ID';
export const UPDATE_TASK_SECTION = 'UPDATE_TASK_SECTION';
export const CLEAR_TASK_SECTION = 'CLEAR_TASK_SECTION';
export const RESET_TASK_TAGS = 'RESET_TASK_TAGS';
export const UPDATE_TASK_TAGS = 'UPDATE_TASK_TAGS';
export const DISASSOCIATE_TASK_TAG = 'DISASSOCIATE_TASK_TAG';
export const ASSOCIATE_TASK_TAG = 'ASSOCIATE_TASK_TAG';
export const REMOVE_TASK_TAGS = 'REMOVE_TASK_TAGS';
export const UPDATE_ENGAGEMENT_TAGS = 'UPDATE_ENGAGEMENT_TAGS';
export const UPDATE_DUE_DATE = 'UPDATE_DUE_DATE';
export const UPDATE_TASK_DETAILS = 'UPDATE_TASK_DETAILS';
export const UPDATE_TASK_STATUS = 'UPDATE_TASK_STATUS';
export const GET_TASK_DOCUMENTS = 'GET_TASK_DOCUMENTS';
export const GET_EVIDENCES = 'GET_EVIDENCES';
export const GET_TASK_DOCUMENTS_STATUS_FLAGS_ONLY = 'GET_TASK_DOCUMENTS_STATUS_FLAGS_ONLY';
export const CLEAR_HANDSOFF_TASK_DOCUMENTS = 'CLEAR_HANDSOFF_TASK_DOCUMENTS';
export const TEST_DOCUMENT_UNDELETE = 'TEST_DOCUMENT_UNDELETE';
export const RESET_TASK_DOCUMENTS = 'RESET_TASK_DOCUMENTS';
export const UPDATE_NOTES_COUNT = 'UPDATE_NOTES_COUNT';
export const TEMP_REMOVE_DOCUMENT = 'TEMP_REMOVE_DOCUMENT';
export const UPDATE_TASK_DOCUMENTS = 'UPDATE_TASK_DOCUMENTS';
export const ASSOCIATE_TASK_DOCUMENTS = 'ASSOCIATE_TASK_DOCUMENTS';
export const UPDATE_GADOCUMENT_STATUSID = 'UPDATE_GADOCUMENT_STATUSID';
export const SEND_DOCUMENTS_TO_PARENT = 'SEND_DOCUMENTS_TO_PARENT';
export const CLEAR_ISDOCUMENTNAME_ALREADY_PRESENT_VALIDATION = 'CLEAR_ISDOCUMENTNAME_ALREADY_PRESENT_VALIDATION';
export const UPDATE_SIGNOFF_ALL_DOCUMENTS = 'UPDATE_SIGNOFF_ALL_DOCUMENTS';
export const UPDATE_SIGNOFF_GIVEN_DOCUMENTS = 'UPDATE_SIGNOFF_GIVEN_DOCUMENTS';
export const UPDATE_SIGNOFF_INDIVIDUAL_DOCUMENT = 'UPDATE_SIGNOFF_INDIVIDUAL_DOCUMENT';
export const APPLY_SIGNOFF_AND_CHANGE_TASK_STATUS = 'APPLY_SIGNOFF_AND_CHANGE_TASK_STATUS';
export const UPDATE_EP_EQR_SIGNOFF_INFO = 'UPDATE_EP_EQR_SIGNOFF_INFO';
export const UPDATE_EP_EQR_SIGNOFF_INFO_TASK_LIST = 'UPDATE_EP_EQR_SIGNOFF_INFO_TASK_LIST';
export const UPDATE_ISBOOKMARK_INFO_TASK_LIST = 'UPDATE_ISBOOKMARK_INFO_TASK_LIST';
export const UPDATE_NOTES_COUNT_TASK_LIST = 'UPDATE_NOTES_COUNT_TASK_LIST';
export const RESET_EP_EQR_USER_SIGNOFF_INFO_INITIAL_STATE = 'RESET_EP_EQR_USER_SIGNOFF_INFO_INITIAL_STATE';
export const UPDATE_EP_SIGNOFFREQUIRED = 'UPDATE_EP_SIGNOFFREQUIRED';
export const UPDATE_EQR_SIGNOFFREQUIRED = 'UPDATE_EQR_SIGNOFFREQUIRED';
export const UPDATE_EP_SIGNOFF_USER_REQUIRED = 'UPDATE_EP_SIGNOFF_USER_REQUIRED';
export const UPDATE_EQR_SIGNOFF_USER_REQUIRED = 'UPDATE_EQR_SIGNOFF_USER_REQUIRED';
export const UPDATE_EP_EQR_SIGNOFF_USER_REQUIRED = 'UPDATE_EP_EQR_SIGNOFF_USER_REQUIRED';
export const UPDATE_REVIEWER_ASSIGNMENT_COMPLETE = 'UPDATE_REVIEWER_ASSIGNMENT_COMPLETE';
export const RESET_SIGN_OFFS_FOR_EVIDENCES = 'RESET_SIGN_OFFS_FOR_EVIDENCES';
export const RESET_EP_EQR_SIGN_OFF_INFO = 'RESET_EP_EQR_SIGN_OFF_INFO';
export const UPDATE_TASK_DOCUMENT = 'UPDATE_TASK_DOCUMENT';
export const DELETE_TASK = 'DELETE_TASK';
export const DELETE_TASKS = 'DELETE_TASKS';
export const CLEAN_DELETE_TASK = 'CLEAN_DELETE_TASK';
export const GET_ENGAGEMENT_ASSIGNMENTS = 'GET_ENGAGEMENT_ASSIGNMENTS';
export const CLEAR_ENGAGEMENT_ASSIGNMENTS = 'CLEAR_ENGAGEMENT_ASSIGNMENTS';
export const GET_TASK_ASSIGNMENTS = 'GET_TASK_ASSIGNMENTS';
export const CLEAR_TASK_ASSIGNMENTS = 'CLEAR_TASK_ASSIGNMENTS';
export const GET_ENGAGEMENT_MEMBERS = 'GET_ENGAGEMENT_MEMBERS';
export const TEAM_MEMBER_ADDED = 'TEAM_MEMBER_ADDED';
export const CLEAR_ENGAGEMENT_MEMBERS = 'CLEAR_ENGAGEMENT_MEMBERS';
export const UPDATE_ENGAGEMENT = 'UPDATE_ENGAGEMENT';
export const UNLINK_ENGAGEMENT_GROUP = 'UNLINK_ENGAGEMENT_GROUP';
export const UPDATE_TASK_MULTIENTITYTYPEID = 'UPDATE_TASK_MULTIENTITYTYPEID';
export const DELETE_TASK_ALL_MULTIENTITIES = 'DELETE_TASK_ALL_MULTIENTITIES';
export const CREATE_TASK_ENTITY_RELATION = 'CREATE_TASK_ENTITY_RELATION';
export const DELETE_TASK_ENTITY_RELATION = 'DELETE_TASK_ENTITY_RELATION';
export const RESET_TASK_DETAIL = 'RESET_TASK_DETAIL';
export const RESET_TASK_ATTRIBUTES = 'RESET_TASK_ATTRIBUTES';
export const RESET_MULTISELECT_TASK_ATTRIBUTES = 'RESET_MULTISELECT_TASK_ATTRIBUTES';
export const RESET_TASK_CATEGORY = 'RESET_TASK_CATEGORY';
export const CLEAR_TASKID_DATA = 'CLEAR_TASKID_DATA';

// Task related items
export const SET_TASK_BOOKMARK = 'SET_TASK_BOOKMARK';
export const GET_BOOKMARK_TASKS = 'GET_BOOKMARK_TASKS';
export const GET_TASK_RELATED_ITEM = 'GET_TASK_RELATED_ITEM';
export const GET_TASK_RELATED_OBJECT = 'GET_TASK_RELATED_OBJECT';
export const RESET_TASK_RELATED_ITEM = 'RESET_TASK_RELATED_ITEM';
export const CLEAR_SELECTED_TASK = 'CLEAR_SELECTED_TASK';
export const SET_SELECTED_TASK = 'SET_SELECTED_TASK';
export const ADD_RELATED_OBJECT = 'ADD_RELATED_OBJECT';
export const DELETE_RELATED_OBJECT = 'DELETE_RELATED_OBJECT';
export const UPDATE_ASSIGNMENTS_TIME_PHASE = 'UPDATE_ASSIGNMENTS_TIME_PHASE';
export const GET_KNOWLEDGE_DESCRIPTIONS = 'GET_KNOWLEDGE_DESCRIPTIONS';
export const GET_TASK_RELATED_ENTITIES = 'GET_TASK_RELATED_ENTITIES';
export const UPDATE_TASK_ASSERTION = 'UPDATE_TASK_ASSERTION';
export const DELETE_TASK_ASSERTION = 'DELETE_TASK_ASSERTION';
export const REFRESH_TASK_ASSERTION = 'REFRESH_TASK_ASSERTION';

// Relate Requests
export const GET_RELATE_REQUESTS = 'GET_RELATE_REQUESTS';
export const RESET_RELATE_REQUESTS = 'RESET_RELATE_REQUESTS';
export const CLEAR_RELATE_REQUESTS = 'CLEAR_RELATE_REQUESTS';
export const Add_RELATED_REQUEST = 'ADD_RELATED_REQUEST';
export const UPDATE_REQUEST_STATUS = 'UPDATE_REQUEST_STATUS';
export const SET_IS_MODAL_OPEN = 'SET_IS_MODAL_OPEN';
export const SET_MODAL_LEVEL = 'SET_MODAL_LEVEL';
export const SET_IS_ADC_MODAL_OPEN = 'SET_IS_ADC_MODAL_OPEN';

// Multi task select
export const ADD_MULTISELECT_TASK = 'ADD_MULTISELECT_TASK';
export const APPEND_MULTISELECT_TASK = 'APPEND_MULTISELECT_TASK';
export const APPEND_MULTISELECT_TASKS = 'APPEND_MULTISELECT_TASKS';
export const REMOVE_MULTISELECT_TASK = 'REMOVE_MULTISELECT_TASK';
export const REMOVE_MULTISELECT_TASKS = 'REMOVE_MULTISELECT_TASKS';
export const CLEAN_MULTISELECT_TASK = 'CLEAN_MULTISELECT_TASK';
export const SET_MULTISELECT_TASK = 'SET_MULTISELECT_TASK';
export const SET_IS_MULTISELECT_TASK = 'SET_IS_MULTISELECT_TASK';
export const RESET_IS_MULTISELECT_TASK = 'RESET_IS_MULTISELECT_TASK';

export const GET_TASK_DESCRIPTION = 'GET_TASK_DESCRIPTION';
export const CLEAN_TASK_DESCRIPTION = 'CLEAN_TASK_DESCRIPTION';
export const SET_NEW_TASK_DESCRIPTION = 'SET_NEW_TASK_DESCRIPTION';
export const UPDATE_TASK_DESCRIPTION = 'UPDATE_TASK_DESCRIPTION';
export const GET_TASK_DOCUMENT_RELATE = 'GET_TASK_DOCUMENT_RELATE';
export const GET_DOCUMENT_TASK_RELATE = 'GET_DOCUMENT_TASK_RELATE';
export const RESET_TASK_DOCUMENT_RELATE = 'RESET_TASK_DOCUMENT_RELATE';
export const UPDATE_TASK_DOCUMENT_RELATE = 'UPDATE_TASK_DOCUMENT_RELATE';
export const GET_TASK_CATEGORIES = 'GET_TASK_CATEGORIES';
export const GET_TASK_SUBCATEGORIES = 'GET_TASK_SUBCATEGORIES';
export const UPDATE_TASK_SUBCATEGORIES = 'UPDATE_TASK_SUBCATEGORIES';
export const SET_TASK_LIST_FILTERS = 'SET_TASK_LIST_FILTERS';
export const RESET_TASK_LIST_FILTERS = 'RESET_TASK_LIST_FILTERS';
export const SET_FILTERS_FROM_SUMMARY = 'SET_FILTERS_FROM_SUMMARY';
export const CLEAR_TASK_LIST_FILTERS = 'CLEAR_TASK_LIST_FILTERS';
export const SET_TASK_LIST_MENU_FILTERS = 'SET_TASK_LIST_MENU_FILTERS';
export const SET_TASK_LIST_MENU_FILTER = 'SET_TASK_LIST_MENU_FILTER';
export const SET_TASK_LIST_MULTIPLE_MENU_FILTER = 'SET_TASK_LIST_MULTIPLE_MENU_FILTER';
export const CLEAR_TASK_LIST_MENU_FILTERS = 'CLEAR_TASK_LIST_MENU_FILTERS';
export const SET_BULK_TASK_LIST_FILTERS = 'SET_BULK_TASK_LIST_FILTERS';
export const RESET_BULK_TASK_LIST_FILTERS = 'RESET_BULK_TASK_LIST_FILTERS';
export const SET_BULK_FILTERS_FROM_SUMMARY = 'SET_BULK_FILTERS_FROM_SUMMARY';
export const CLEAR_BULK_TASK_LIST_FILTERS = 'CLEAR_BULK_TASK_LIST_FILTERS';
export const SET_BULK_TASK_LIST_MENU_FILTERS = 'SET_BULK_TASK_LIST_MENU_FILTERS';
export const SET_BULK_TASK_LIST_MENU_FILTER = 'SET_BULK_TASK_LIST_MENU_FILTER';
export const SET_BULK_TASK_LIST_MULTIPLE_MENU_FILTER = 'SET_BULK_TASK_LIST_MULTIPLE_MENU_FILTER';
export const CLEAR_BULK_TASK_LIST_MENU_FILTERS = 'CLEAR_BULK_TASK_LIST_MENU_FILTERS';
export const RESET_BULK_TASK_CATEGORY = 'RESET_BULK_TASK_CATEGORY';
export const BULK_TASK_REMOVE_TASK_FROM_SELECTED_TASKS = 'BULK_TASK_REMOVE_TASK_FROM_SELECTED_TASKS';
export const BULK_TASK_ADD_ALL_TASKS_TO_SELECTED_TASKS = 'BULK_TASK_ADD_ALL_TASKS_TO_SELECTED_TASKS';
export const BULK_TASK_REMOVE_ALL_TASKS_FROM_SELECTED_TASKS = 'BULK_TASK_REMOVE_ALL_TASKS_FROM_SELECTED_TASKS';
export const BULK_TASK_ADD_TASK_TO_SELECTED_TASKS = 'BULK_TASK_ADD_TASK_TO_SELECTED_TASKS';
export const BULK_TASK_CHANGE_ASSIGN_TO_TYPE = 'BULK_TASK_CHANGE_ASSIGN_TO_TYPE';
export const BULK_TASK_DEFAULT_ASSIGN_TO_TYPE = 'BULK_TASK_DEFAULT_ASSIGN_TO_TYPE';
export const BULK_DELETE_TASK_ASSIGNMENT = 'BULK_DELETE_TASK_ASSIGNMENT';

// Bulk Mode Requests List
export const ADD_OR_REMOVE_REQUEST_ID_TO_BULK_LIST = 'ADD_OR_REMOVE_REQUEST_ID_TO_BULK_LIST';
export const CLEAR_BULK_REQUEST_LIST = 'CLEAR_BULK_REQUEST_LIST';
export const SET_LIST_OF_BULK_REQUESTS = 'SET_LIST_OF_BULK_REQUESTS';

export const SET_TASK_LIST_VIEW = 'SET_TASK_LIST_VIEW';
export const SET_TASK_DOCUMENT_TAB = 'SET_TASK_DOCUMENT_TAB';
export const SET_IS_TASKS_GROUP = 'SET_IS_TASKS_GROUP';
export const CLEAR_TASK_SUBCATEGORIES = 'CLEAR_TASK_SUBCATEGORIES';
export const CLEAR_TASK_LIST = 'CLEAR_TASK_LIST';
export const CLEAR_TASK_LIST_SERVICE_REQUEST = 'CLEAR_TASK_LIST_SERVICE_REQUEST';
export const RESET_TASK_LIST = 'RESET_TASK_LIST';
export const GET_ENGAGEMENT = 'GET_ENGAGEMENT';
export const GET_ALL_ENGAGEMENTS = 'GET_ALL_ENGAGEMENTS';
export const GET_SERVICE_OFFERINGS = 'GET_SERVICE_OFFERINGS';
export const GET_TASK_SERVICE_OFFERINGS = 'GET_TASK_SERVICE_OFFERINGS';
export const GET_ENGAGEMENT_USERS_WITHROLES = 'GET_ENGAGEMENT_USERS_WITHROLES';
export const SELECT_ENGAGEMENT_USERROLE_ITEM = 'SELECT_ENGAGEMENT_USERROLE_ITEM';
export const LOAD_ENGAGEMENTMETADATA = 'LOAD_ENGAGEMENTMETADATA';
export const GET_ENGAGEMENT_PROFILE_DATA = 'GET_ENGAGEMENT_PROFILE_DATA';
export const CREATE_TASK = 'CREATE_TASK';
export const GET_CREATED_TASK_DETAILS = 'GET_CREATED_TASK_DETAILS';
export const GET_SCOTS = 'GET_SCOTS';
export const GET_SCOT_COUNT_WITHOUTTASKS = 'GET_SCOT_COUNT_WITHOUTTASKS';
export const CLEAR_SCOTS = 'CLEAR_SCOTS';
export const GET_IT_PROCESSES = 'GET_IT_PROCESSES';
export const GET_IT_UNRELATED_PROCESS = 'GET_IT_UNRELATED_PROCESS';
export const GET_ALL_IT_PROCESSES = 'GET_ALL_IT_PROCESSES';
export const CLEAR_IT_PROCESSES = 'CLEAR_IT_PROCESSES';
export const GET_ALL_ST_ENTITIES = 'GET_ALL_ST_ENTITIES';
export const GET_WORKSPACE_ENGAGEMENTS = 'GET_WORKSPACE_ENGAGEMENTS';
export const CLEAN_WORKSPACE_ENGAGEMENTS = 'CLEAN_WORKSPACE_ENGAGEMENTS';

/**Task Types */
export const GET_ENTITY_TASKS = 'GET_ENTITY_TASKS';
export const LINK_ITPROCESS_RELATE_TASK = 'LINK_ITPROCESS_RELATE_TASK';
export const UNLINK_ITPROCESS_RELATE_TASK = 'UNLINK_ITPROCESS_RELATE_TASK';
export const SET_LOADER_FOR_RELATED_TASK = 'SET_LOADER_FOR_RELATED_TASK';
export const RELATE_ITPROCESS_TASK = 'RELATE_ITPROCESS_TASK';
export const ADD_RELATED_TASK = 'ADD_RELATED_TASK';
export const GET_RELATED_WCGWS = 'GET_RELATED_WCGWS';
export const GET_UNRELATED_TASKS = 'GET_UNRELATED_TASKS';
export const LINK_CONTROL_RELATE_TASK = 'LINK_CONTROL_RELATE_TASK';
export const UNLINK_CONTROL_RELATE_TASK = 'UNLINK_CONTROL_RELATE_TASK';

export const GET_TASK_REVIEWNOTE_STATUS_FILTER = 'GET_TASK_REVIEWNOTE_STATUS_FILTER';
export const GET_DOCUMENT_REVIEWNOTE_STATUS_FILTER = 'GET_DOCUMENT_REVIEWNOTE_STATUS_FILTER';
export const GET_REVIEWNOTE = 'GET_REVIEWNOTE';
export const CLEAR_REVIEWNOTE = 'CLEAR_REVIEWNOTE';
export const CLEAR_OTHER_ENGAGEMENTS_REVIEWNOTES = 'CLEAR_OTHER_ENGAGEMENTS_REVIEWNOTES';
export const GET_ENGAGEMENT_TEAM_MEMBERS = 'GET_ENGAGEMENT_TEAM_MEMBERS';
export const GET_HAND_OFF_USERS = 'GET_HAND_OFF_USERS';
export const GET_HAND_OFF_USERS_ID = 'GET_HAND_OFF_USERS_ID';
export const Add_REVIEW_NOTE = 'Add_REVIEW_NOTE';
export const SELECT_REVIEW_NOTE_FROM_USER = 'SELECT_REVIEW_NOTE_FROM_USER';
export const SELECT_REVIEW_NOTE_TO_USER = 'SELECT_REVIEW_NOTE_TO_USER';
export const SELECT_REVIEW_NOTE_PRIORITY = 'SELECT_REVIEW_NOTE_PRIORITY';
export const SELECT_REVIEW_NOTE_DUE_DATE = 'SELECT_REVIEW_NOTE_DUE_DATE';
export const SELECT_TASK_DOCUMENT = 'SELECT_TASK_DOCUMENT';
export const UPDATE_REVIEW_NOTE_TEXT = 'UPDATE_REVIEW_NOTE_TEXT';
export const CLEAR_NEW_REVIEW_NOTE = 'CLEAR_NEW_REVIEW_NOTE';
export const CLEAR_EDIT_REVIEW_NOTE_ERROR = 'CLEAR_EDIT_REVIEW_NOTE_ERROR';
export const SHOW_EDIT_REVIEW_NOTE_ERROR = 'SHOW_EDIT_REVIEW_NOTE_ERROR';
export const UPDATE_REVIEW_NOTE_STATUS = 'UPDATE_REVIEW_NOTE_STATUS';
export const GET_REVIEWNOTES_COUNT = 'GET_REVIEWNOTES_COUNT';
export const GET_REVIEWNOTES_AUTHOREDBY_COUNT = 'GET_REVIEWNOTES_AUTHOREDBY_COUNT';
export const GET_OTHERENGAGEMENTS_REVIEWNOTES = 'GET_OTHERENGAGEMENTS_REVIEWNOTES';
export const DELETE_REVIEW_NOTE = 'DELETE_REVIEW_NOTE';
export const CREATE_REVIEW_NOTE = 'CREATE_REVIEW_NOTE';
export const UPDATE_SINGLE_REVIEW_NOTE_STATUS = 'UPDATE_SINGLE_REVIEW_NOTE_STATUS';
export const UPDATE_REVIEW_NOTE = 'UPDATE_REVIEW_NOTE';
export const GET_TASKS_WCGWS = 'GET_TASKS_WCGWS';
export const CHANGE_TASK_STATUS = 'CHANGE_TASK_STATUS';
export const REVIEWNOTE_CATERGORY = 'REVIEWNOTE_CATERGORY';

//------------ Task list operations: Start -----------------
export const TASK_LIST_LOADED = 'TASK_LIST_LOADED';
//------------ Task list operations: End -----------------

//------------ File Upload constants:Start ----------------
export const CLIENT_VALIDATION_ERROR = 'CLIENT_VALIDATION_ERROR';
export const SEND_FILES_TO_DOCHELPER = 'SEND_FILES_TO_DOCHELPER';
export const CHECK_IF_DOCHELPER_ONLINE = 'CHECK_IF_DOCHELPER_ONLINE';
export const DOCHELPER_DOWNLOAD_DOCUMENT = 'DOCHELPER_DOWNLOAD_DOCUMENT';
export const DOCUMENT_DOWNLOAD_COMPLETE = 'DOCUMENT_DOWNLOAD_COMPLETE';
export const DOCUMENT_DOWNLOAD_PROGRESS = 'DOCUMENT_DOWNLOAD_PROGRESS';
export const DOCHELPER_BULK_DOWNLOAD = 'DOCHELPER_BULK_DOWNLOAD';
export const DOCHELPER_UPLOAD_DOCUMENT = 'DOCHELPER_UPLOAD_DOCUMENT';
export const DOCUMENT_UPLOAD_PROGRESS = 'DOCUMENT_UPLOAD_PROGRESS';
export const DOCHELPER_ERROR = 'DOCHELPER_ERROR';
export const START_OFFLINE_SYNC = 'START_OFFLINE_SYNC';
//------------ File Upload constants:End ----------------
export const GET_USER_PREFERENCES = 'GET_USER_PREFERENCES';
export const CLEAN_KENDO_VALUE_LENGTH = 'CLEAN_KENDO_VALUE_LENGTH';
export const SET_IS_PREFERENCES_LOADED = 'SET_IS_PREFERENCES_LOADED';
export const GET_DOCUMENTS_RELATED_TASKS = 'GET_DOCUMENTS_RELATED_TASKS';
export const ADD_DOCUMENTS_TO_TASKS = 'ADD_DOCUMENTS_TO_TASKS';
export const LOAD_WORKSPACES = 'LOAD_WORKSPACES';
export const LOAD_MY_WORKSPACES = 'LOAD_MY_WORKSPACES';
export const UPDATE_DOCUMENT_METADATA = 'UPDATE_DOCUMENT_METADATA';
export const CREATE_DOCUMENT_COPY = 'CREATE_DOCUMENT_COPY';
export const CREATE_DOCUMENT_METADATA = 'CREATE_DOCUMENT_METADATA';
export const GET_EXISTING_TEMPORARY_DOCUMENT = 'GET_EXISTING_TEMPORARY_DOCUMENT';
export const CLEAN_EXISTING_TEMPORARY_DOCUMENT = 'CLEAN_EXISTING_TEMPORARY_DOCUMENT';
export const CREATE_PAPER_PROFILE_METADATA = 'CREATE_PAPER_PROFILE_METADATA';

export const USER_SETTINGS = 'USER_SETTINGS';

export const GET_RISKS = 'GET_RISKS';
export const GET_RISKS_With_ACCOUNTS_ASSERTIONS = 'GET_RISKS_With_ACCOUNTS_ASSERTIONS';
export const GET_RISK_LIST = 'GET_RISK_LIST';
export const GET_RISK_LIST_WITH_NO_SUBSTANTIVE_COUNT = 'GET_RISK_LIST_WITH_NO_SUBSTANTIVE_COUNT';
export const GET_RISK_BY_ID = 'GET_RISK_BY_ID';
export const GET_All_RISKS = 'GET_All_RISKS';
export const GET_RISKS_FOR_WCGWID = 'GET_RISKS_FOR_WCGWID';
export const GET_RELATED_RISKS_FOR_WCGWID = 'GET_RELATED_RISKS_FOR_WCGWID';
export const GET_RISK_TYPES = 'GET_RISK_TYPES';
export const GET_RISKS_BY_TYPE = 'GET_RISKS_BY_TYPE';
export const DELETE_RISK = 'DELETE_RISK';
export const UPDATE_RISK = 'UPDATE_RISK';
export const MANAGE_RISK = 'MANAGE_RISK';
export const CREATE_RISK = 'CREATE_RISK';
export const CLEAR_NEW_RISK = 'CLEAR_NEW_RISK';
export const CLEAR_RISK = 'CLEAR_RISK';
export const CREATE_ASSERTION_RISK_RELATION = 'CREATE_ASSERTION_RISK_RELATION';
export const DELETE_ASSERTION_RISK_RELATION = 'DELETE_ASSERTION_RISK_RELATION';
export const UPDATE_ASSERTION_RISK_RELATION = 'UPDATE_ASSERTION_RISK_RELATION';
export const UPDATE_ASSERTION_IR_CR = 'UPDATE_ASSERTION_IR_CR';
export const CREATE_RISK_FORMBODYOPTION = 'CREATE_RISK_FORMBODYOPTION';
export const DELETE_RISK_FORMBODYOPTION = 'DELETE_RISK_FORMBODYOPTION';
export const GET_RESPONSIVE_TASKS_CONTROLS_BY_RISKID = 'GET_RESPONSIVE_TASKS_CONTROLS_BY_RISKID';
export const GET_RISK_BY_ID_WITH_ACCOUNTS_ASSERTIONS = 'GET_RISK_BY_ID_WITH_ACCOUNTS_ASSERTIONS';
export const GET_ASSERTIONS_FOR_ENGAGEMENTID = 'GET_ASSERTIONS_FOR_ENGAGEMENTID';
export const GET_ASSERTIONS_FOR_RISKID = 'GET_ASSERTIONS_FOR_RISKID';
export const GET_SCOTS_FOR_ASSERTIONID = 'GET_SCOTS_FOR_ASSERTIONID';
export const GET_ASSERTIONS_FOR_ACCOUNTID = 'GET_ASSERTIONS_FOR_ACCOUNTID';
export const GET_ASSERTIONS_FOR_ACCOUNTID_SEM = 'GET_ASSERTIONS_FOR_ACCOUNTID_SEM';
export const GET_REVIEWS_FOR_ACCOUNTID = 'GET_REVIEWS_FOR_ACCOUNTID';
export const DELETE_REVIEWS_FOR_ACCOUNTID = 'DELETE_REVIEWS_FOR_ACCOUNTID';
export const ADD_REVIEWS_FOR_ACCOUNTID = 'ADD_REVIEWS_FOR_ACCOUNTID';
export const UPDATE_SCOT_WCGW_CHECKED = 'UPDATE_SCOT_WCGW_CHECKED';
export const SET_SEM_SELECTED_ASSERTIONS = 'SET_SEM_SELECTED_ASSERTIONS';
export const SET_ACCOUNT_LIST_FILTERS = 'SET_ACCOUNT_LIST_FILTERS';
export const UNRELATE_ALL_SCOT_FROM_ACCOUNT_WHEN_DELETED = 'UNRELATE_ALL_SCOT_FROM_ACCOUNT_WHEN_DELETED';
export const UNRELATE_ACCOUNT_FROM_ALL_SCOTS_WHEN_DELETED = 'UNRELATE_ACCOUNT_FROM_ALL_SCOTS_WHEN_DELETED';
export const UPDATE_ALL_SCOT_IN_ACCOUNT_LIST_WHEN_SCOT_UPDATED = 'UPDATE_ALL_SCOT_IN_ACCOUNT_LIST_WHEN_SCOT_UPDATED';

export const SET_RISKID_ASSERTIONID = 'SET_RISKID_ASSERTIONID';
export const SAVE_RISK_WCGW_SELECTION = 'SAVE_RISK_WCGW_SELECTION';

export const SET_RISK_WCGW_SELECTED = 'SET_RISK_WCGW_SELECTED';
export const CREATE_RISK_TASK_RELATION = 'CREATE_RISK_TASK_RELATION';
export const DELETE_RISK_TASK_RELATION = 'DELETE_RISK_TASK_RELATION';

export const CREATE_WCGW_ASSERTION = 'CREATE_WCGW_ASSERTION';
export const DELETE_WCGW_ASSERTION = 'DELETE_WCGW_ASSERTION';

export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const GET_ACCOUNT_VALIDATION_COUNT = 'GET_ACCOUNT_VALIDATION_COUNT';
export const GET_ACCOUNTS_MANAGE = 'GET_ACCOUNTS_MANAGE';
export const GET_ALL_ACCOUNTS = 'GET_ALL_ACCOUNTS';
export const GET_ACCOUNT_LIST = 'GET_ACCOUNT_LIST';
export const GET_ACCOUNT_LIST_BY_ID = 'GET_ACCOUNT_LIST_BY_ID';
export const GET_ACCOUNTS_WITHOUT_SUBSTANTIVE_PROCEDURE_COUNT = 'GET_ACCOUNTS_WITHOUT_SUBSTANTIVE_PROCEDURE_COUNT';
export const GET_ACCOUNT_BY_ID = 'GET_ACCOUNT_BY_ID';
export const CLEAR_ACCOUNTS = 'CLEAR_ACCOUNTS';
export const GET_ACCOUNTS_EDIT = 'GET_ACCOUNTS_EDIT';
export const ADD_NEW_ACCOUNT = 'ADD_NEW_ACCOUNT';
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const REFRESH_TASK_IN_ACCOUNT = 'REFRESH_TASK_IN_ACCOUNT';
export const CLEAR_ACCOUNT = 'CLEAR_ACCOUNT';
export const POST_ACCOUNT_SCOT_RELATION = 'POST_ACCOUNT_SCOT_RELATION';
export const UPDATE_ACCOUNT_SCOT_RELATION = 'UPDATE_ACCOUNT_SCOT_RELATION';
export const UPDATE_ACCOUNT_WCGW_CONTROL_RELATION = 'UPDATE_ACCOUNT_WCGW_CONTROL_RELATION';
export const UPDATE_HAS_CONTROL_TESTING = 'UPDATE_HAS_CONTROL_TESTING';
export const UPDATE_SCOT_ACCOUNT_RELATION = 'UPDATE_SCOT_ACCOUNT_RELATION';
export const UPDATE_ALL_ACCOUNT_IN_SCOTLIST_WHEN_ACCOUNT_UPDATED =
	'UPDATE_ALL_ACCOUNT_IN_SCOTLIST_WHEN_ACCOUNT_UPDATED';
export const FILTER_SCOTS_BY_ACCOUNT_TYPE = 'FILTER_SCOTS_BY_ACCOUNT_TYPE';
export const DELETE_SCOT_FROM_ACCOUNT = 'DELETE_SCOT_FROM_ACCOUNT';
export const UPDATE_STORE_UNRELATE_CONTROL_FROM_WCGW = 'UPDATE_STORE_UNRELATE_CONTROL_FROM_WCGW';
export const UPDATE_STORE_RELATE_CONTROL_TO_WCGW = 'UPDATE_STORE_RELATE_CONTROL_TO_WCGW';
export const RELOAD_ACCOUNTS = 'RELOAD_ACCOUNTS';
export const UPDATE_UNRELATE_ITAPPLICATION_FROM_SCOT = 'UPDATE_UNRELATE_ITAPPLICATION_FROM_SCOT';
export const MANAGE_ITAPPLICATION_FROM_BUILD_STEP_2 = 'MANAGE_ITAPPLICATION_FROM_BUILD_STEP_2';
export const MODIFY_ITAPPLICATION_TO_SCOT = 'MODIFY_ITAPPLICATION_TO_SCOT';
export const CLEAR_ITAPPSO_SCOT = 'CLEAR_ITAPPSO_SCOT';

export const GET_ACCOUNT_BY_DOCUMENTID = 'GET_ACCOUNT_BY_DOCUMENTID';

export const GET_TASK_RELATED_REQUESTS = 'GET_TASK_RELATED_REQUESTS';
export const GET_SCOTS_FOR_ASSERTIONIDS = 'GET_SCOTS_FOR_ASSERTIONIDS';
export const UPDATE_SCOT_EXPANDED = 'UPDATE_SCOT_EXPANDED';
// Document name
export const UPDATE_DOCUMENT_NAME = 'UPDATE_DOCUMENT_NAME';
export const DELETE_DOCUMENT_ITEM = 'DELETE_DOCUMENT_ITEM';
export const CLEAN_DOCUMENT_ITEM = 'CLEAN_DOCUMENT_ITEM';
export const UPDATE_ANALYTIC_DOCUMENT_NAME = 'UPDATE_ANALYTIC_DOCUMENT_NAME';

// Configurations
export const GET_CONFIGURATIONS = 'GET_CONFIGURATIONS';
export const GET_COUNTRY_STATUS = 'GET_COUNTRY_STATUS';
export const SET_AUTOMTION_SERVICE_TIMEOUT = 'SET_AUTOMTION_SERVICE_TIMEOUT';
export const CLEAR_AUTOMTION_SERVICE_TIMEOUT = 'CLEAR_AUTOMTION_SERVICE_TIMEOUT';

/*Validation Counts*/
export const GET_VALIDATIONCOUNTS = 'GET_VALIDATIONCOUNTS';
export const GET_VALIDATIONDETAILS = 'GET_VALIDATIONDETAILS';
export const UNLOAD_VALIDATION_COUNTS = 'UNLOAD_VALIDATION_COUNTS';
export const UNLOAD_VALIDATION_DETAILS = 'UNLOAD_VALIDATION_DETAILS';
export const REFRESH_VALIDATION_COUNTS = 'REFRESH_VALIDATION_COUNTS';
export const CAN_ENABLE_AND_DISPLAY_MARK_COMPLETE = 'CAN_ENABLE_AND_DISPLAY_MARK_COMPLETE';
export const IS_ASSIGNMENT_MARKED_FOR_COMPLETION = 'IS_ASSIGNMENT_MARKED_FOR_COMPLETION';
export const DELETE_TASK_ASSIGNMENT = 'DELETE_TASK_ASSIGNMENT';
export const DELETE_USER_TASK_ASSIGNMENT = 'DELETE_USER_TASK_ASSIGNMENT';
export const REPLACE_MEMBER_TASK_ASSIGNMENT = 'REPLACE_MEMBER_TASK_ASSIGNMENT';
export const DELETE_TASK_DOCUMENT_RELATE = 'DELETE_TASK_DOCUMENT_RELATE';
export const GET_IS_LAST_ASOCIATED_TASK = 'GET_IS_LAST_ASOCIATED_TASK';
export const CLEAN_IS_LAST_ASOCIATED_TASK = 'CLEAN_IS_LAST_ASOCIATED_TASK';
export const CREATE_TASK_ASSIGNMENT = 'CREATE_TASK_ASSIGNMENT';
export const CLEAR_PREPARER_ASSIGNMENT = 'CLEAR_PREPARER_ASSIGNMENT';
export const BULK_DELETE_MEMBER_TASK_ASSIGNMENTS = 'BULK_DELETE_MEMBER_TASK_ASSIGNMENTS';

/*Arc Timeline */
export const SUBMIT_ARCHIVE = 'SUBMIT_ARCHIVE';

/*Arc Timeline Validations*/
export const GET_ARCTIMELINE_VALIDATIONS = 'GET_ARCTIMELINE_VALIDATIONS';
export const CLEAN_ARCTIMELINE_VALIDATION = 'CLEAN_ARCTIMELINE_VALIDATION';
export const GET_ARCTIMELINE_GROUP_VALIDATION = 'GET_ARCTIMELINE_GROUP_VALIDATION';
export const GET_FORM_VALIDATIONS = 'GET_FORM_VALIDATIONS';
export const GET_ARCTIMELINE_VALIDATIONS_AFTER_RESPONSE = 'GET_ARCTIMELINE_VALIDATIONS_AFTER_RESPONSE';
export const GET_ARCTIMELINE_CHECKLIST = 'GET_ARCTIMELINE_CHECKLIST';
export const UPDATE_ARCTIMELINE_CHECKLIST = 'UPDATE_ARCTIMELINE_CHECKLIST';
export const UPDATE_CHECKLIST_TOGGLE = 'UPDATE_CHECKLIST_TOGGLE';
export const UPDATE_CHECKLIST_ACTIVITY_STATUS = 'UPDATE_CHECKLIST_ACTIVITY_STATUS';

/*Related Findings*/
export const GET_RELATED_FINDINGS = 'GET_RELATED_FINDINGS';
export const CLEAN_RELATED_DEFICIENCIES = 'CLEAN_RELATED_DEFICIENCIES';
export const EDIT_TASK_TITLE = 'EDIT_TASK_TITLE';
export const EDIT_MULTI_TASK_TITLE = 'EDIT_MULTI_TASK_TITLE';
export const GET_TASK_GROUPS_SECTIONS = 'GET_TASK_GROUPS_SECTIONS';
export const CREATE_TASK_GROUPS = 'CREATE_TASK_GROUPS';
export const CLEAR_TASK_GROUPS_SECTIONS = 'CLEAR_TASK_GROUPS_SECTIONS';

/*Misstatements*/
export const GET_MISSTATEMENTS_BY_DOCUMENTID = 'GET_MISSTATEMENTS_BY_DOCUMENTID';
export const GET_MISSTATEMENTS = 'GET_MISSTATEMENTS';
export const REMOVE_DOCUMENT_FROM_MISSTATEMENT = 'REMOVE_DOCUMENT_FROM_MISSTATEMENT';
export const RELATE_DOCUMENT_FROM_MISSTATEMENT = 'RELATE_DOCUMENT_FROM_MISSTATEMENT';
export const ADD_ADJUSTMENT = 'ADD_ADJUSTMENT';
export const UPDATE_MISSTATEMENT = 'UPDATE_MISSTATEMENT';
export const GET_MISSTATEMENT_BY_ID = 'GET_MISSTATEMENT_BY_ID';
export const GET_ALL_MISSTATEMENTS = 'GET_ALL_MISSTATEMENTS';
export const DELETE_MISSTATEMENT_BY_ID = 'DELETE_MISSTATEMENT_BY_ID';

/* Validations */
export const GET_VALIDATIONS = 'GET_VALIDATIONS';

/*Deficiencies*/
export const GET_DEFICIENCIES_BY_DOCUMENTID = 'GET_DEFICIENCIES_BY_DOCUMENTID';

/* Milestones Build Tasks */
export const GET_MILESTONES_BUILD_TASKS = 'GET_MILESTONES_BUILD_TASKS';
export const CLEAN_MILESTONES_BUILD_TASKS = 'CLEAN_MILESTONES_BUILD_TASKS';

/* Build Step - Add due date */
export const ADD_TIMEPHASE_UNDER_MILESTONE = 'ADD_TIMEPHASE_UNDER_MILESTONE';
export const UPDATE_TIMEPHASE_UNDER_MILESTONE = 'UPDATE_TIMEPHASE_UNDER_MILESTONE';
export const DELETE_TIMEPHASE_UNDER_MILESTONE = 'DELETE_TIMEPHASE_UNDER_MILESTONE';

/* Build Step - Events */
export const GET_CALENDER_EVENTS = 'GET_CALENDER_EVENTS';
export const ADD_CALENDAR_EVENT = 'ADD_CALENDAR_EVENT';
export const EDIT_CALENDAR_EVENT = 'EDIT_CALENDAR_EVENT';
export const DELETE_EVENT = 'DELETE_EVENT';

/* Time phases */
export const GET_TIME_PHASE = 'GET_TIME_PHASE';
export const GET_MILESTONES = 'GET_MILESTONES';
export const ADD_TIMEPHASE = 'ADD_TIMEPHASE';
export const EDIT_TIMEPHASE = 'EDIT_TIMEPHASE';
export const DELETE_TIMEPHASE = 'DELETE_TIMEPHASE';
export const UPDATE_TASK_TIME_PHASES = 'UPDATE_TASK_TIME_PHASES';
export const UPDATE_BULK_TASK_TIME_PHASES = 'UPDATE_BULK_TASK_TIME_PHASES';
export const UPDATE_TASKLIST_ON_DELETE_TIME_PHASE = 'UPDATE_TASKLIST_ON_DELETE_TIME_PHASE';
export const GET_TIMEPHASES = 'GET_TIMEPHASES';
/* Group Tasks */
export const GET_GROUP_AUDIT_TASKS = 'GET_GROUP_AUDIT_TASKS';
export const GET_GROUP_AUDIT_SCOPES = 'GET_GROUP_AUDIT_SCOPES';
export const CLEAN_GROUP_AUDIT_SCOPES = 'CLEAN_GROUP_AUDIT_SCOPES';
export const GET_PENDING_EVIDENCE = 'GET_PENDING_EVIDENCE';
export const GET_COMPONENTS = 'GET_COMPONENTS';
export const ASSIGN_REGION_COMPONENT = 'ASSIGN_REGION_COMPONENT';
export const UPDATE_DOCUMENT_REGION_COMPONENT = 'UPDATE_DOCUMENT_REGION_COMPONENT';
export const CLEAN_PENDING_EVIDENCE = 'CLEAN_PENDING_EVIDENCE';
/* WCGWs */
export const GET_WCGWS = 'GET_WCGWS';
export const GET_WCGWS_BY_SCOTID = 'GET_WCGWS_BY_SCOTID';
export const PUT_WCGW_TASK = 'PUT_WCGW_TASK';
export const DELETE_WCGW_TASK = 'DELETE_WCGW_TASK';

export const GET_DOCUMENT = 'GET_DOCUMENT';
export const CLEAN_DOCUMENT = 'CLEAN_DOCUMENT';

export const SET_REVIEWNOTE_DOCUMENT = 'SET_REVIEWNOTE_DOCUMENT';
export const CLEAN_REVIEWNOTE_DOCUMENT = 'CLEAN_REVIEWNOTE_DOCUMENT';

export const GET_TIME_PHASES = 'GET_TIME_PHASES';
export const GET_OPEN_ASSIGNMENT_ROLES = 'GET_OPEN_ASSIGNMENT_ROLES';
export const GET_OPEN_ASSIGNMENT_USERS = 'GET_OPEN_ASSIGNMENT_USERS';
export const GET_ENGAGEMENT_USERS = 'GET_ENGAGEMENT_USERS';
export const GET_ENGAGEMENT_ENTITIES = 'GET_ENGAGEMENT_ENTITIES';

/*Documents*/
export const PATCH_DOCUMENT_VERSION = 'PATCH_DOCUMENT_VERSION';

export const GET_ALL_DOCUMENTS = 'GET_ALL_DOCUMENTS';

export const GET_ALL_REFERENCE_DOCS = 'GET_ALL_REFERENCE_DOCS';
export const DELETE_REFERENCE_DOC = 'DELETE_REFERENCE_DOC';
export const ADD_REFERENCE_DOC = 'ADD_REFERENCE_DOC';

export const GET_RELATED_REFERENCE_DOCS = 'GET_RELATED_REFERENCE_DOCS';

export const GET_DOCUMENT_SIGN_OFFS = 'GET_DOCUMENT_SIGN_OFFS';
export const LOAD_SIGN_OFF = 'LOAD_SIGN_OFF';

export const ADD_DUPLICATE_DOCUMENT = 'ADD_DUPLICATE_DOCUMENT';
export const CLEAR_DUPLICATE_DOCUMENTS = 'CLEAR_DUPLICATE_DOCUMENTS';
export const SELECT_DOCUMENT_OVERWRITE = 'SELECT_DOCUMENT_OVERWRITE';
export const GET_ALL_DOCUMENTS_SEARCH = 'GET_ALL_DOCUMENTS_SEARCH';
export const GET_ALL_DOCUMENTS_CLEAN = 'GET_ALL_DOCUMENTS_CLEAN';
export const ADD_GLACCOUNT_DOCUMENT = 'ADD_GLACCOUNT_DOCUMENT';
export const DELETE_GLACCOUNT_DOCUMENT = 'DELETE_GLACCOUNT_DOCUMENT';
export const UPDATE_GLACCOUNT_DOCUPLOAD_COUNT = 'UPDATE_GLACCOUNT_DOCUPLOAD_COUNT';

export const GET_DOCUMENT_BY_ID = 'GET_DOCUMENT_BY_ID';
export const GET_DOCUMENT_HISTORY = 'GET_DOCUMENT_HISTORY';
export const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT';
export const UNLINK_SHARED_DOCUMENT = 'UNLINK_SHARED_DOCUMENT';
export const UNLINK_ALL_SHARED_DOCUMENTS = 'UNLINK_ALL_SHARED_DOCUMENTS';

export const ADD_APPROVAL_FOR_DOCUMENT = 'ADD_APPROVAL_FOR_DOCUMENT';
export const REMOVE_APPROVAL_FOR_DOCUMENT = 'REMOVE_APPROVAL_FOR_DOCUMENT';
export const CREATE_SNAPSHOT = 'CREATE_SNAPSHOT';

export const DELETE_DOCUMENT_BY_ID = 'DELETE_DOCUMENT_BY_ID';
export const DELETE_DOCUMENT_VERSION_BY_ID = 'DELETE_DOCUMENT_VERSION_BY_ID';

export const CREATE_DOCUMENT_REVIEW = 'CREATE_DOCUMENT_REVIEW';
export const DELETE_DOCUMENT_REVIEW = 'DELETE_DOCUMENT_REVIEW';

export const GET_ALL_DOCUMENT_EXTENSION = 'GET_ALL_DOCUMENT_EXTENSION';
export const CREATE_DOCUMENT_EXTENSION_CHANGE_COMMENT = 'CREATE_DOCUMENT_EXTENSION_CHANGE_COMMENT';
export const UPDATE_DOCUMENT_EXTENSION_CHANGE_COMMENT = 'UPDATE_DOCUMENT_EXTENSION_CHANGE_COMMENT';

export const RESTORE_DOCUMENT_VERSION = 'RESTORE_DOCUMENT_VERSION';

export const GET_OVERWRITE_DOCUMENTS = 'GET_OVERWRITE_DOCUMENTS';
export const GET_OVERWRITE_FORMS = 'GET_OVERWRITE_FORMS';
export const POST_OVERWRITE_DOCUMENT = 'POST_OVERWRITE_DOCUMENT';
export const CREATE_DOCUMENT_SNAPSHOT = 'CREATE_DOCUMENT_SNAPSHOT';
export const RESET_OVERWRITE = 'RESET_OVERWRITE';
export const DOWNLOAD_DOCUMENT = 'DOWNLOAD_DOCUMENT';
export const GET_QUICK_ACCESS_DOCUMENT = 'GET_QUICK_ACCESS_DOCUMENT';
export const GET_SCOPE_AND_STRATEGY_GUIDED_WORKFLOW = 'GET_SCOPE_AND_STRATEGY_GUIDED_WORKFLOW';

export const CHECK_IN_CHECK_OUT_DOCUMENT = 'CHECK_IN_CHECK_OUT_DOCUMENT';
export const DAAS_DOCUMENT_IN_PROGRESS = 'DAAS_DOCUMENT_IN_PROGRESS';

//#region Redux state management
export const GET_DOCUMENT_LIST = 'GET_DOCUMENT_LIST';
export const SET_DOCUMENT_LIST_FILTERS = 'SET_DOCUMENT_LIST_FILTERS';
export const MERGE_DOCUMENT_LIST_FILTERS = 'MERGE_DOCUMENT_LIST_FILTERS';
export const SET_DOCUMENT_LIST_FILTER = 'SET_DOCUMENT_LIST_FILTER';
export const CLEAR_DOCUMENT_LIST_FILTERS = 'CLEAR_DOCUMENT_LIST_FILTERS';
export const REFRESH_DOCUMENT_LIST = 'REFRESH_DOCUMENT_LIST';
export const CLEAR_DOCUMENT_LIST = 'CLEAR_DOCUMENT_LIST';
export const CLEAR_CUSTOM_FILTERS = 'CLEAR_CUSTOM_FILTERS';
export const CLEAR_DOCUMENT_BY_ID = 'CLEAR_DOCUMENT_BY_ID';
export const ADD_DOCUMENT_TO_LIST = 'ADD_DOCUMENT_TO_LIST';
export const GET_DASHBOARD_DOCUMENT_LIST = 'GET_DASHBOARD_DOCUMENT_LIST';
export const RESET_DOCUMENT_LIST = 'RESET_DOCUMENT_LIST';
export const GET_DOCUMENT_RELATED_TASKS = 'GET_DOCUMENT_RELATED_TASKS';
export const SET_DOCUMENT_LIST_ENTITY_VIEW = 'SET_DOCUMENT_LIST_ENTITY_VIEW';

export const CLEAR_DOCUMENT_LIST_HISTORY = 'CLEAR_DOCUMENT_LIST_HISTORY';
export const UPDATE_DOCUMENT_LIST_BY_ID = 'UPDATE_DOCUMENT_LIST_BY_ID';
export const UPDATE_DOCUMENT_LIST_BY_PARENTNAME = 'UPDATE_DOCUMENT_LIST_BY_PARENTNAME';
export const SELECT_DOCUMENT_LIST_BY_ID = 'SELECT_DOCUMENT_LIST_BY_ID';
export const SELECT_DOCUMENT_LIST_BY_RANGE = 'SELECT_DOCUMENT_LIST_BY_RANGE';

export const CREATE_DOCUMENT = 'CREATE_DOCUMENT';
export const ADD_DOCUMENT_TO_EVIDENCE = 'ADD_DOCUMENT_TO_EVIDENCE';
export const RELATE_DOCUMENT_TO_CANVAS_FORMS = 'RELATE_DOCUMENT_TO_CANVAS_FORMS';
//#endregion

/* 440GL documents */
export const SET_CHANGE_REASON_REQUIRED = 'SET_CHANGE_REASON_REQUIRED';
export const SHOW_CHANGE_REASON_MODAL = 'SHOW_CHANGE_REASON_MODAL';

/* Assignment */
export const GET_REVIEW_ASSIGNMENTS = 'GET_REVIEW_ASSIGNMENTS';
export const RESET_REVIEW_ASSIGNMENTS = 'RESET_REVIEW_ASSIGNMENTS';
export const GET_STATUS_ASSIGNMENTS = 'GET_STATUS_ASSIGNMENTS';
export const CLEAR_STATUS_ASSIGNMENTS = 'CLEAR_STATUS_ASSIGNMENTS';
export const SAVE_ENGAGEMENT_ASSIGNMENT = 'SAVE_ENGAGEMENT_ASSIGNMENT';
export const EDIT_TASK_ASSIGNMENTS = 'EDIT_TASK_ASSIGNMENTS';
export const CHANGE_TASK_ASSIGNMENT_STATUS = 'CHANGE_TASK_ASSIGNMENT_STATUS';
export const GET_ASSIGNMENTS_TASKS = 'GET_ASSIGNMENTS_TASKS';
export const GET_ASSIGNMENTS = 'GET_ASSIGNMENTS';
export const CREATE_ASSIGNMENTS = 'CREATE_ASSIGNMENTS';
export const CREATE_ASSIGNMENTS_TO_LIST = 'CREATE_ASSIGNMENTS_TO_LIST';
export const CLEAN_ASSIGNMENTS = 'CLEAN_ASSIGNMENTS';
export const EDIT_ASSIGNMENTS = 'EDIT_ASSIGNMENTS';
export const DELETE_ASSIGNMENTS = 'DELETE_ASSIGNMENTS';
export const RESET_FLAG_ASSIGNMENTS = 'RESET_FLAG_ASSIGNMENTS';
export const GET_USER_ASSIGNMENTS = 'GET_USER_ASSIGNMENTS';

/* Mange Assignment */
export const GET_MANAGE_ASSIGNMENTS = 'GET_MANAGE_ASSIGNMENTS';
export const GET_MANAGE_ASSIGNMENTS_TASKS = 'GET_MANAGE_ASSIGNMENTS_TASKS';
export const CLEAN_MANAGE_ASSIGNMENTS = 'CLEAN_MANAGE_ASSIGNMENTS';
export const GET_MANAGE_ASSIGNMENTS_BYID = 'GET_MANAGE_ASSIGNMENTS_BYID';
export const GET_ASSIGNMENTS_BY_ASSIGNMENT_ID = 'GET_ASSIGNMENTS_BY_ASSIGNMENT_ID';

/* get guidance section data  */
export const GET_TASK_GUIDANCE = 'GET_TASK_GUIDANCE';

/* Sign offs/Approvals constants */
export const ADD_APPROVAL_FOR_TASK = 'ADD_APPROVAL_FOR_TASK';
export const ADD_APPROVAL_FOR_SEM = 'ADD_APPROVAL_FOR_SEM';
export const DELETE_APPROVAL_FOR_TASK = 'DELETE_APPROVAL_FOR_TASK';
export const DELETE_APPROVAL_FOR_SEM = 'DELETE_APPROVAL_FOR_SEM';
export const CLEAN_APPROVAL = 'CLEAN_APPROVAL';
export const REMOVE_TASK_DOCUMENT = 'REMOVE_TASK_DOCUMENT';
export const UNBOOKMARK_TASK = 'UNBOOKMARK_TASK';

/* REVIEW NOTES HUB */
export const GET_RNH_NOTES = 'GET_RNH_NOTES';
export const UPDATE_RNH_NOTES_DATA = 'UPDATE_RNH_NOTES_DATA';
export const CLEAN_RNH_NOTES = 'CLEAN_RNH_NOTES';
export const EMPTY_RNH_NOTES = 'EMPTY_RNH_NOTES';
export const ADD_RNH_NOTE_FROM_LIST = 'ADD_RNH_NOTE_FROM_LIST';
export const SET_RNH_FILTER = 'SET_RNH_FILTER';
export const SET_RNH_FILTERS = 'SET_RNH_FILTERS';
export const CLEAR_RNH_FILTERS = 'CLEAR_RNH_FILTERS';
export const UPDATE_RNH_NOTE_DETAIL = 'UPDATE_RNH_NOTE_DETAIL';
export const EDIT_RNH_NOTE = 'EDIT_RNH_NOTE';
export const DELETE_RNH_NOTE_FROM_LIST = 'DELETE_RNH_NOTE_FROM_LIST';
export const GET_FILTER_OPTIONS = 'GET_FILTER_OPTIONS';
export const CLEAN_FILTER_OPTIONS = 'CLEAN_FILTER_OPTIONS';
export const GET_RNH_NOTE_DETAIL = 'GET_RNH_NOTE_DETAIL';
export const GET_REMAINING_COMMENTS = 'GET_REMAINING_COMMENTS';
export const CLEAR_RNH_NOTE_DETAIL = 'CLEAR_RNH_NOTE_DETAIL';
export const OPEN_RNH_NOTE_DETAIL_MODAL = 'OPEN_RNH_NOTE_DETAIL_MODAL';
export const CLOSE_RNH_NOTE_DETAIL_MODAL = 'CLOSE_RNH_NOTE_DETAIL_MODAL';
export const SET_RNH_SELECTED_NOTE_ID = 'SET_RNH_SELECTED_NOTE_ID';
export const SET_RNH_SELECTED_NOTE_ID_RESET_CONTEXT = 'SET_RNH_SELECTED_NOTE_ID_RESET_CONTEXT';
export const CLEAN_RNH_SELECTED_NOTE_ID = 'CLEAN_RNH_SELECTED_NOTE_ID';
export const POST_RNH_NOTE_REPLY = 'POST_RNH_NOTE_REPLY';
export const POST_RNH_NEW_NOTE = 'POST_RNH_NEW_NOTE';
export const SET_BULK_PRIORITY_TYPE = 'SET_BULK_PRIORITY_TYPE';
export const UPDATE_RNH_NOTES_BULK = 'UPDATE_RNH_NOTES_BULK';
export const UPDATE_RNH_NOTE_INFO = 'UPDATE_RNH_NOTE_INFO';
export const DELETE_RNH_NOTE_DETAIL = 'DELETE_RNH_NOTE_DETAIL';
export const UPDATE_RNH_NOTES_COUNT = 'UPDATE_RNH_NOTES_COUNT';
export const GET_RNH_NOTE_REPLIES = 'GET_RNH_NOTE_REPLIES';
export const DELETE_RNH_NOTE = 'DELETE_RNH_NOTE';
export const DELETE_RNH_PARENT_NOTE = 'DELETE_RNH_PARENT_NOTE';
export const PIC_EQR_SET_RNH_FILTERS = 'PIC_EQR_SET_RNH_FILTERS';
export const PIC_EQR_SET_RNH_FILTER = 'PIC_EQR_SET_RNH_FILTER';
export const PIC_EQR_CLEAN_RNH_NOTES = 'PIC_EQR_CLEAN_RNH_NOTES';
export const PIC_EQR_CLEAR_RNH_FILTERS = 'PIC_EQR_CLEAR_RNH_FILTERS';
export const COMMON_SET_RNH_FILTERS = 'COMMON_SET_RNH_FILTERS';
export const COMMON_SET_RNH_FILTERS_BYKEY = 'COMMON_SET_RNH_FILTERS_BYKEY';
export const COMMON_SET_RNH_FILTER = 'COMMON_SET_RNH_FILTER';
export const COMMON_CLEAR_RNH_FILTERS = 'COMMON_CLEAR_RNH_FILTERS';

export const ADD_RNH_MULTIPLE_ONE_NOTE = 'ADD_RNH_MULTIPLE_ONE_NOTE';
export const APPEND_RNH_MULTIPLE_NOTE = 'APPEND_RNH_MULTIPLE_NOTE';
export const SET_RNH_MULTIPLE_NOTE = 'SET_RNH_MULTIPLE_NOTE';
export const SELECT_RNH_MULTIPLE_ALL_NOTES = 'SELECT_RNH_MULTIPLE_ALL_NOTES';
export const CLEAN_RNH_MULTIPLE_ALL_NOTES = 'CLEAN_RNH_MULTIPLE_ALL_NOTES';
export const SET_RNH_BULK_SELECTION = 'SET_RNH_BULK_SELECTION';
export const REMOVE_MULTISELECT_NOTE = 'REMOVE_MULTISELECT_NOTE';
export const SET_RNH_MULTIPLE_NOTES_CONTEXT = 'SET_RNH_MULTIPLE_NOTES_CONTEXT';
export const UPDATE_RNH_MULTIPLE_NOTES_BULK_CONTEXT = 'UPDATE_RNH_MULTIPLE_NOTES_BULK_CONTEXT';

/*Media Playing */
export const SET_IS_MEDIA_PLAYING = 'SET_IS_MEDIA_PLAYING';

export const GET_FORM_BODY_COMMENT = 'GET_FORM_BODY_COMMENT';

/*Forms*/
export const GET_FORM_DATA = 'GET_FORM_DATA';
export const GET_FORM_BODIES_BY_SECTIONID = 'GET_FORM_BODIES_BY_SECTIONID';
export const GET_FORM_BODIES_AFTER_RESPONSE = 'GET_FORM_BODIES_AFTER_RESPONSE';

/*Manage Team*/
export const SET_EXTERNAL_TAB_VISIBLE = 'SET_EXTERNAL_TAB_VISIBLE';
export const SET_MANAGE_TEAM_MAIN_HEADER_TEXT = 'SET_MANAGE_TEAM_MAIN_HEADER_TEXT';
export const SET_INDEPENDANCE_COL_VISIBLE = 'SET_INDEPENDANCE_COL_VISIBLE';
export const SET_STATUS_COL_VISIBLE = 'SET_STATUS_COL_VISIBLE';
export const SET_ACTIONS_COL_VISIBLE = 'SET_ACTIONS_COL_VISIBLE';
export const SET_POST_ARCHIVE_COL_VISIBLE = 'SET_POST_ARCHIVE_COL_VISIBLE';
export const SET_ADD_EDIT_MODAL_TEXTS = 'SET_ADD_EDIT_MODAL_TEXTS';
export const SET_PRIOR_PERIOD_BUTTON_VISIBLE = 'SET_PRIOR_PERIOD_BUTTON_VISIBLE';
export const SET_ADD_THIRD_PARTY_MEMBER_BUTTON_VISIBLE = 'SET_ADD_THIRD_PARTY_MEMBER_BUTTON_VISIBLE';
export const SET_SHOULD_CALL_VALIDATION = 'SET_SHOULD_CALL_VALIDATION';

export const GET_INTERNAL_USERS = 'GET_INTERNAL_USERS';
export const GET_INTERNAL_USER_BY_ID = 'GET_INTERNAL_USER_BY_ID';
export const CLEAR_INTERNAL_USERS = 'CLEAR_INTERNAL_USERS';
export const CLEAR_INTERNAL_USER = 'CLEAR_INTERNAL_USER';
export const POST_INTERNAL_USER = 'POST_INTERNAL_USER';
export const GET_DOCUMENT_CHANGE_TYPES = 'GET_DOCUMENT_CHANGE_TYPES';
export const GET_CLIENT_GROUPS = 'GET_CLIENT_GROUPS';
export const GET_CLIENT_GROUP_DETAILS = 'GET_CLIENT_GROUP_DETAILS ';
export const CLEAR_CLIENT_GROUPS = 'CLEAR_CLIENT_GROUPS';
export const CLEAR_CLIENT_GROUP = 'CLEAR_CLIENT_GROUP';
export const ADD_CLIENT_GROUP = 'ADD_CLIENT_GROUP';
export const PUT_CLIENT_GROUP = 'PUT_CLIENT_GROUP';
export const DELETE_CLIENT_GROUP = 'DELETE_CLIENT_GROUP';
export const PUT_INTERNAL_USER = 'PUT_INTERNAL_USER';
export const UPDATE_INTERNAL_USER_RBAC_ROLE_STATE = 'UPDATE_INTERNAL_USER_RBAC_ROLE_STATE';

export const INCREMENT_DOMAIN_VALIDATION_COUNTER = 'INCREMENT_DOMAIN_VALIDATION_COUNTER';

export const POST_INDEPENDENCE_FORM_CREATION = 'POST_INDEPENDENCE_FORM_CREATION';

export const GET_EXTERNAL_USERS_LIST = 'GET_EXTERNAL_USERS_LIST';
export const GET_EXTERNAL_USER_BY_ID = 'GET_EXTERNAL_USER_BY_ID';
export const PATCH_ALL_EXTERNAL_USER = 'PATCH_ALL_EXTERNAL_USER';
export const PATCH_EXTERNAL_USER = 'PATCH_EXTERNAL_USER';
export const PUT_EXTERNAL_USER = 'PUT_EXTERNAL_USER';
export const CLEAR_EXTERNAL_USERS = 'CLEAR_EXTERNAL_USERS';
export const SAVE_EXTERNAL_USER = 'SAVE_EXTERNAL_USER';
export const CLEAR_EXTERNAL_USER = 'CLEAR_EXTERNAL_USER';

export const GET_PRIOR_PERIOD_USERS_LIST = 'GET_PRIOR_PERIOD_USERS_LIST';
export const GET_ALL_ENGAGEMENT_USER_ROLES = 'GET_ALL_ENGAGEMENT_USER_ROLES';
export const GET_ALL_CONFIDENTIALITY_TYPES = 'GET_ALL_CONFIDENTIALITY_TYPES';
export const GET_ALL_RBAC_USER_ROLES = 'GET_ALL_RBAC_USER_ROLES';
export const SET_ENGAGEMENT_USER_ROLE = 'SET_ENGAGEMENT_USER_ROLE';
export const ADD_SELECTED_USER = 'ADD_SELECTED_USER';
export const REMOVE_SELECTED_USER = 'REMOVE_SELECTED_USER';
export const ADD_ALL_USER = 'ADD_ALL_USER';
export const CLEAR_ALL_USERS = 'CLEAR_ALL_USERS';
export const PATCH_INVITE_PRIOR_PERIOD_USERS = 'PATCH_INVITE_PRIOR_PERIOD_USERS';
export const PATCH_DEACTIVATE_USERS_LIST = 'PATCH_DEACTIVATE_USERS_LIST';

export const ADD_INTERNAL_SELECTED_USER = 'ADD_INTERNAL_SELECTED_USER';
export const REMOVE_INTERNAL_SELECTED_USER = 'REMOVE_INTERNAL_SELECTED_USER';
export const CLEAR_INTERNAL_ALL_SELECTED_USERS = 'CLEAR_INTERNAL_ALL_SELECTED_USERS';

export const ADD_EXTERNAL_SELECTED_USER = 'ADD_EXTERNAL_SELECTED_USER';
export const REMOVE_EXTERNAL_SELECTED_USER = 'REMOVE_EXTERNAL_SELECTED_USER';
export const CLEAR_EXTERNAL_ALL_SELECTED_USERS = 'CLEAR_EXTERNAL_ALL_SELECTED_USERS';

/* Copy Hub */
export const GET_COPYHUB_PACKAGE_LIST = 'GET_COPYHUB_PACKAGE_LIST';
export const RESET_PACKAGE_LIST = 'RESET_PACKAGE_LIST';
export const GET_COPYHUB_PACKAGE_DETAILS = 'GET_COPYHUB_PACKAGE_DETAILS';
export const RESET_PACKAGE_DETAILS_MODAL = 'RESET_PACKAGE_DETAILS_MODAL';
export const GET_PACKAGE_FILE_SIZES = 'GET_PACKAGE_FILE_SIZES';
export const SET_ASSOCIATE_TASK_COUNTER = 'SET_ASSOCIATE_TASK_COUNTER';

/* Content Update */
export const UPDATE_SELECTED_CONTENT = 'UPDATE_SELECTED_CONTENT';
export const GET_CONTENT_UPDATE_HISTORY = 'GET_CONTENT_UPDATE_HISTORY';
export const GET_PSP_ACCOUNTS = 'GET_PSP_ACCOUNTS';

export const GET_CANVAS_FORM_UPDATES = 'GET_CANVAS_FORM_UPDATES';
export const CLEAR_CANVAS_FORM_UPDATES = 'CLEAR_CANVAS_FORM_UPDATES';

/*user search*/
export const GET_USER_SEARCH = 'GET_USER_SEARCH';

/*Dashboard */
export const GET_AUDITPHASE_MILESTONE_DETAILS = 'GET_AUDITPHASE_MILESTONE_DETAILS';
export const GET_MILESTONE_DETAILS = 'GET_MILESTONE_DETAILS';
export const GET_AUDITPHASE_MILESTONE_DETAILS_EXECUTIVEREVIEW = 'GET_AUDITPHASE_MILESTONE_DETAILS_EXECUTIVEREVIEW';
export const LOAD_INSTRUCTIONS = 'LOAD_INSTRUCTIONS';

export const UPDATE_FORM_BODY_RESPONSE = 'UPDATE_FORM_BODY_RESPONSE';

/*Dashboard*/
export const GET_COLLABORATION_COUNTS = 'GET_COLLABORATION_COUNTS';
export const GET_SDM_SUMMARY = 'GET_SDM_SUMMARY';
export const CLEAR_SDM_SUMMARY = 'CLEAR_SDM_SUMMARY';

/*DashboardV2*/
export const GET_GROUP_AUDIT_COMPONENTS = 'GET_GROUP_AUDIT_COMPONENTS';
export const CLEAR_GROUP_AUDIT_COMPONENTS = 'CLEAR_GROUP_AUDIT_COMPONENTS';
export const UPDATE_GROUP_TASKS_FILTERS = 'UPDATE_GROUP_TASKS_FILTERS';
export const SET_GA_COMPONENT_TREE = 'SET_GA_COMPONENT_TREE';
export const CLEAR_GA_COMPONENT_TREE = 'CLEAR_GA_COMPONENT_TREE';
export const UPDATE_TEAMS_CHECKED = 'UPDATE_TEAMS_CHECKED';
export const CLEAR_TEAMS_CHECKED = 'CLEAR_TEAMS_CHECKED';
export const GET_ENTITY_DETAILS = 'GET_ENTITY_DETAILS';
export const GET_MATERIALITY = 'GET_MATERIALITY';

/*PIC DashboardV2*/
export const SET_PIC_MENU_FILTERS = 'SET_PIC_MENU_FILTERS';
export const SET_PIC_MENU_FILTER = 'SET_PIC_MENU_FILTER';
export const SET_PIC_FILTERS = 'SET_PIC_FILTERS';
export const SET_PIC_MULTIPLE_MENU_FILTER = 'SET_PIC_MULTIPLE_MENU_FILTER';
export const UPDATE_PIC_BASIC_FILTERS = 'UPDATE_PIC_BASIC_FILTERS';
export const SET_PIC_SEARCH_FILTER = 'SET_PIC_SEARCH_FILTER';
export const CLEAR_PIC_FILTERS = 'CLEAR_PIC_FILTERS';
export const SET_PIC_EQR_DOCUMENT_LIST_FILTER = 'SET_PIC_EQR_DOCUMENT_LIST_FILTER';
export const SET_PIC_EQR_DOCUMENT_LIST_FILTERS = 'SET_PIC_EQR_DOCUMENT_LIST_FILTERS';
export const CLEAR_PIC_EQR_DOCUMENT_LIST_FILTERS = 'CLEAR_PIC_EQR_DOCUMENT_LIST_FILTERS';
export const UPDATE_PIC_EQR_PAGINATION_STATE = 'UPDATE_PIC_EQR_PAGINATION_STATE';
export const SYNC_PIC_EQR_DOCUMENT_LIST_TILE = 'SYNC_PIC_EQR_DOCUMENT_LIST_TILE';
export const AUTO_ASSIGN_PIC_EQR_TASK = 'AUTO_ASSIGN_PIC_EQR_TASK';

/*Reporting*/
export const GET_REPORT_DATA = 'GET_REPORT_DATA';
export const GET_CANVAS_FORM_REPORT = 'GET_CANVAS_FORM_REPORT';
export const GET_CONTROL_FORM_REPORT = 'GET_CONTROL_FORM_REPORT';

/*Quick Links*/
export const GET_QUICKLINKS_BY_ENGAGEMENTID = 'GET_QUICKLINKS_BY_ENGAGEMENTID';

/*Milestone Local Reducers Action Types*/
export const SET_MILESTONE_TRANSFORM_DATA = 'SET_MILESTONE_TRANSFORM_DATA';

export const SET_MILESTONE_SHOW_TAB = 'SET_MILESTONE_SHOW_TAB';

export const SET_MILESTONE_VIEWBYTIMEPHASE = 'SET_MILESTONE_VIEWBYTIMEPHASE';

export const UPDATE_MILESTONE_DATA = 'UPDATE_MILESTONE_DATA';
/*Milestone Local Reducers Action Types Ends here*/

/* Helix Project Integration */
export const GET_PROJECTS_BY_CLIENTCODE = 'GET_PROJECTS_BY_CLIENTCODE';

export const GET_PROJECTS_BY_ENGAGEMENTCODE = 'GET_PROJECTS_BY_ENGAGEMENTCODE';

export const GET_PROJECTS_BY_USEREMAIL = 'GET_PROJECTS_BY_USEREMAIL';

export const GET_PROJECTS_BY_DUNSNUMBER = 'GET_PROJECTS_BY_DUNSNUMBER';

/* Helix Linked Projects */

export const GET_LINKED_PROJECTS_BY_ENGAGEMENTID = 'GET_LINKED_PROJECTS_BY_ENGAGEMENTID';

export const GET_LINKED_PROJECT_BY_PROJECTID = 'GET_LINKED_PROJECT_BY_PROJECTID';

export const CLEAR_LINKED_PROJECTS = 'CLEAR_LINKED_PROJECTS';

export const POST_LINKED_PROJECTS_BY_ENGAGEMENTID = 'POST_LINKED_PROJECTS_BY_ENGAGEMENTID';

export const UPDATE_LINKED_PROJECT_BY_ENGAGEMENTID_AND_PROJECTID =
	'UPDATE_LINKED_PROJECT_BY_ENGAGEMENTID_AND_PROJECTID';

export const UPDATE_MAPPED_ENTITIES = 'UPDATE_MAPPED_ENTITIES';

// TODO: remove on v2 integration
export const DELETE_LINKED_PROJECT_BY_ENGAGEMENTID_AND_PROJECTID =
	'DELETE_LINKED_PROJECT_BY_ENGAGEMENTID_AND_PROJECTID';

export const POST_HELIX_PROJECT = 'POST_HELIX_PROJECT';
export const CLEAR_HELIX_PROJECT = 'CLEAR_HELIX_PROJECT';
export const DELETE_HELIX_PROJECT = 'DELETE_HELIX_PROJECT';

export const DELETE_LINKED_PROJECT_BY_ENGAGEMENTID_AND_ENGAGEMENTHELIXID =
	'DELETE_LINKED_PROJECT_BY_ENGAGEMENTID_AND_ENGAGEMENTHELIXID';

/* Helix Get GL Accounts Status By Project Id */
export const GET_GL_ACCOUNT_STATUS_BY_PROJECTID = 'GET_GL_ACCOUNT_STATUS_BY_PROJECTID';

/* Helix Get Active Projects By User Id */
export const GET_ACTIVE_PROJECTS_BY_PROJECTIDS = 'GET_ACTIVE_PROJECTS_BY_PROJECTIDS';

export const GET_PROJECT_FILTERMETADATA_BY_PROJECTID_FROM_HELIX = 'GET_PROJECT_FILTERMETADATA_BY_PROJECTID_FROM_HELIX';
export const CLEAR_PROJECT_FILTERMETADATA = 'CLEAR_PROJECT_FILTERMETADATA';

export const IS_VALID_USER_WITH_PROJECT_AVAILABLE = 'IS_VALID_USER_WITH_PROJECT_AVAILABLE';

/* Helix Max Connection Reached */
export const POST_HELIX_ANALYZER_MAX_CONNECTION_REACHED = 'POST_HELIX_ANALYZER_MAX_CONNECTION_REACHED';
export const CLEAR_HELIX_ANALYZER_MAX_CONNECTION_REACHED = 'CLEAR_HELIX_ANALYZER_MAX_CONNECTION_REACHED';

/* Helix Multi Entity Import */
export const GET_HELIX_CONNECTION_ENTITIES = 'GET_HELIX_CONNECTIN_ENTITIES';
export const CLEAR_HELIX_CONNETION_ENTITIES = 'CLEAR_HELIX_CONNETION_ENTITIES';

/* Content Update */
export const GET_CONTENT_UPDATE_TYPES = 'GET_CONTENT_UPDATE_TYPES';

/* PAANS */
export const CHECK_USER_ACCEPTED_PAANS_POLICY = 'CHECK_USER_ACCEPTED_PAANS_POLICY';

//#region Filters
export const BULK_QUICK_FILTER = 'BULK_QUICK_FILTER';
export const SET_FILTERS = 'SET_FILTERS';
export const SET_MULTIPLE_FILTERS = 'SET_MULTIPLE_FILTERS';
export const SET_TASKS_MULTIPLE_MENU_FILTER = 'SET_TASKS_MULTIPLE_MENU_FILTER';
export const ENABLE_FILTER = 'ENABLE_FILTER';
export const DISABLE_FILTER = 'DISABLE_FILTER';
export const GET_FILTER_ENTITIES = 'GET_FILTER_ENTITIES';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS';
export const SET_FILTER = 'SET_FILTER';
export const SET_LOAD_STATE = 'SET_LOAD_STATE';
//#endregion

//#region bulk Filters
export const SET_BULK_FILTERS = 'SET_BULK_FILTERS';
export const SET_BULK_MULTIPLE_FILTERS = 'SET_BULK_MULTIPLE_FILTERS';
export const UPDATE_BULK_FILTER = 'UPDATE_BULK_FILTER';
export const ENABLE_BULK_FILTER = 'ENABLE_BULK_FILTER';
export const DISABLE_BULK_FILTER = 'DISABLE_BULK_FILTER';
export const GET_BULK_FILTER_ENTITIES = 'GET_BULK_FILTER_ENTITIES';
export const UPDATE_BULK_FILTER_ENTITIES = 'UPDATE_BULK_FILTER_ENTITIES';
export const CLEAR_BULK_FILTERS = 'CLEAR_BULK_FILTERS';
export const CLEAR_BULK_ALL_FILTERS = 'CLEAR_BULK_ALL_FILTERS';
//#endregion

/* User Presence */
export const GET_USER_PRESENCE = 'GET_USER_PRESENCE';
export const RESET_USER_PRESENCE = 'RESET_USER_PRESENCE';
export const DELETE_USER_PRESENCE = 'DELETE_USER_PRESENCE';

/* Independence Confirmations */
export const GET_ENGAGMENT_USER_INDEPENDENCE = 'GET_ENGAGMENT_USER_INDEPENDENCE';
export const CLEAN_ENGAGMENT_USER_INDEPENDENCE = 'CLEAN_ENGAGMENT_USER_INDEPENDENCE';
export const GET_INDEPENDENCE_VALIDATIONS = 'GET_INDEPENDENCE_VALIDATIONS';
export const GET_INDEPENDENCE_SUMMARY = 'GET_INDEPENDENCE_SUMMARY';
export const GET_INDEPENDENCE_RESPONSES = 'GET_INDEPENDENCE_RESPONSES';
export const CREATE_INDEPENDENCE_FORM = 'CREATE_INDEPENDENCE_FORM';
export const REMOVE_INDEPENDENCE_OVERRIDE = 'REMOVE_INDEPENDENCE_OVERRIDE';
export const REMOVE_INDEPENDENCE_TEAM_MEMBER = 'REMOVE_INDEPENDENCE_TEAM_MEMBER';

// Add canvas form
export const GET_CANVASFORM_LANGUAGES = 'GET_CANVASFORM_LANGUAGES';
export const CLEAR_CANVASFORM_LANGUAGES = 'CLEAR_CANVASFORM_LANGUAGES';
export const GET_CANVASFORM_COUNTRYS = 'GET_CANVASFORM_COUNTRYS';
export const CLEAR_CANVASFORM_COUNTRYS = 'CLEAR_CANVASFORM_COUNTRYS';
export const GET_CANVASFORM_TYPES = 'GET_CANVASFORM_TYPES';
export const CLEAR_CANVASFORM_TYPES = 'CLEAR_CANVASFORM_TYPES';
export const GET_CANVASFORM_RELATED_TASKS = 'GET_CANVASFORM_RELATED_TASKS';
export const ADD_CANVASFORM_RELATED_TASK = 'ADD_CANVASFORM_RELATED_TASK';
export const ADD_ALL_CANVASFORM_RELATED_TASKS = 'ADD_ALL_CANVASFORM_RELATED_TASKS';
export const REMOVE_CANVASFORM_RELATED_TASK = 'REMOVE_CANVASFORM_RELATED_TASK';
export const RESET_TASK_SELECTION = 'RESET_TASK_SELECTION';
export const CLOSE_CANVAS_FORM_COMBINED = 'CLOSE_CANVAS_FORM_COMBINED';
export const SET_DEFAULT_TASK_SELECTION = 'SET_DEFAULT_TASK_SELECTION';
export const REMOVE_ALL_CANVASFORM_RELATED_TASKS = 'REMOVE_ALL_CANVASFORM_RELATED_TASKS';
export const GET_CANVASFORM_RELATED_OBJECTS = 'GET_CANVASFORM_RELATED_OBJECTS';
export const ADD_CANVASFORM_RELATED_OBJECT = 'ADD_CANVASFORM_RELATED_OBJECT';
export const ADD_ALL_CANVASFORM_RELATED_OBJECTS = 'ADD_ALL_CANVASFORM_RELATED_OBJECTS';
export const REMOVE_CANVASFORM_RELATED_OBJECT = 'REMOVE_CANVASFORM_RELATED_OBJECT';
export const REMOVE_ALL_CANVASFORM_RELATED_OBJECTS = 'REMOVE_ALL_CANVASFORM_RELATED_OBJECTS';
export const RESET_OBJECT_SELECTION = 'RESET_OBJECT_SELECTION';
export const RESET_OBJECT_LIST = 'RESET_OBJECT_LIST';
export const SET_CANVASFORM_GAMLAYER_WITH_COUNTRY_LANGUAGE = 'SET_CANVASFORM_GAMLAYER_WITH_COUNTRY_LANGUAGE';
export const CLEAR_CANVASFORM_GAMLAYER_WITH_COUNTRY_LANGUAGE = 'CLEAR_CANVASFORM_GAMLAYER_WITH_COUNTRY_LANGUAGE';
export const CREATE_FORM_PROFILE = 'CREATE_FORM_PROFILE';
export const CREATE_RELATED_OBJECT = 'CREATE_RELATED_OBJECT';
export const INITIATE_CONTENT_UPDATE = 'INITIATE_CONTENT_UPDATE';
export const SET_CREATE_MANUAL_FORM_SUCCESS_MESSAGE = 'SET_CREATE_MANUAL_FORM_SUCCESS_MESSAGE';
export const SET_IS_ADD_CANVAS_FORM_MODAL_OPEN = 'SET_IS_ADD_CANVAS_FORM_MODAL_OPEN';
export const GET_SERVICE_LINE = 'GET_SERVICE_LINE';
export const CLEAR_SERVICE_LINE = 'CLEAR_SERVICE_LINE';
export const GET_CANVAS_FORM_CHILD_DOCUMENTS = 'GET_CANVAS_FORM_CHILD_DOCUMENTS';

// Tags
export const GET_ALL_ENGAGEMENT_TAGS = 'GET_ALL_ENGAGEMENT_TAGS';
export const GET_ALL_TAGS = 'GET_ALL_TAGS';
export const GET_ALL_TAGS_BY_ACCOUNTIDS = 'GET_ALL_TAGS_BY_ACCOUNTIDS';

// Tag Groups
export const GET_ALL_TAG_GROUPS = 'GET_ALL_TAG_GROUPS';

// Bulk Tags
export const BULK_ASSOCIATE_TASK_TAG = 'BULK_ASSOCIATE_TASK_TAG';
export const BULK_ADD_TAGS_TO_METADATA = 'BULK_ADD_TAGS_TO_METADATA';

//Manage tags
export const CREATE_TAG = 'CREATE_TAG';
export const UPDATE_TAG = 'UPDATE_TAG';
export const DELETE_TAG = 'DELETE_TAG';
export const DELETE_ENGAGEMENT_TAG = 'DELETE_ENGAGEMENT_TAG';
export const CREATE_TAG_GROUP = 'CREATE_TAG_GROUP';
export const UPDATE_TAG_GROUP = 'UPDATE_TAG_GROUP';
export const DELETE_TAG_GROUP = 'DELETE_TAG_GROUP';
export const UPDATE_TASKLIST_ON_DELETE_TAGS = 'UPDATE_TASKLIST_ON_DELETE_TAGS';
export const ADD_TAG_GROUP = 'ADD_TAG_GROUP';
export const UPDATE_TASKLIST_ON_EDIT_TAG = 'UPDATE_TASKLIST_ON_EDIT_TAG';
export const UPDATE_TAG_ENTITY_COUNT = 'UPDATE_TAG_ENTITY_COUNT';

//Next Wave
export const RESET_SERVICE_REQUEST_DETAIL = 'RESET_SERVICE_REQUEST_DETAIL';
export const GET_TASK_SERVICE_REQUESTS = 'GET_TASK_SERVICE_REQUESTS';
export const UPDATE_SERVICE_REQUEST_SELECTED_TASKS = 'UPDATE_SERVICE_REQUEST_SELECTED_TASKS';
export const UPDATE_SERVICE_REQUEST_SELECTED_ALL_TASKS = 'UPDATE_SERVICE_REQUEST_SELECTED_ALL_TASKS';
export const SELECT_LIST_ITEM_ROWS = 'SELECT_LIST_ITEM_ROWS';
export const CONSTRUCT_EMPTY_SERVICE_REQUEST_WITH_SERVICE_OFFERING =
	'CONSTRUCT_EMPTY_SERVICE_REQUEST_WITH_SERVICE_OFFERING';

//List Sorting
export const UPDATE_SORTING_PROPS = 'UPDATE_SORTING_PROPS';
export const CLEAR_SORTING_PROPS = 'CLEAR_SORTING_PROPS';

//Automation Request
export const GET_AUTOMATION_REQUEST = 'GET_AUTOMATION_REQUEST';

//Timeout actions
export const START_IDLE_TIMER = 'START_IDLE_TIMER';
export const START_LOGOUT = 'START_LOGOUT';
export const SHOW_IDLETIME_POPUP = 'SHOW_IDLETIME_POPUP';
export const RESET_IDLE_TIMER = 'RESET_IDLE_TIMER';
//Canvas form update filters
export const SET_CANVAS_FORM_UPDATE_MENU_FILTERS = 'SET_CANVAS_FORM_UPDATE_MENU_FILTERS';
export const SET_CANVAS_FORM_UPDATE_MENU_FILTER = 'SET_CANVAS_FORM_UPDATE_MENU_FILTER';
export const CLEAR_CANVAS_FORM_UPDATE_MENU_FILTERS = 'CLEAR_CANVAS_FORM_UPDATE_MENU_FILTERS';
export const SET_CANVAS_FORM_UPDATE_FILTERS = 'SET_CANVAS_FORM_UPDATE_FILTERS';
export const RESET_CANVAS_FORM_UPDATE_FILTERS = 'RESET_CANVAS_FORM_UPDATE_FILTERS';
export const CLEAR_CANVAS_FORM_UPDATE_FILTERS = 'CLEAR_CANVAS_FORM_UPDATE_FILTERS';

//relate task automation
export const RELATE_TASK_AUTOMATION = 'RELATE_TASK_AUTOMATION';

//Copyhub create package
export const UPDATE_PACKAGE_TYPE_DETAILS = 'UPDATE_PACKAGE_TYPE_DETAILS';
export const UPDATE_PACKAGE_CATEGORY_DETAILS = 'UPDATE_PACKAGE_CATEGORY_DETAILS';
export const GET_PACKAGE_TYPE_DETAILS = 'GET_PACKAGE_TYPE_DETAILS';
/* Activity feed actions */
export const GET_ACTIVITY_FEED_SUMMARY = 'GET_ACTIVITY_FEED_SUMMARY';
export const CLEAN_ACTIVITY_FEED = 'CLEAN_ACTIVITY_FEED';
export const SET_ACTIVITY_FEED_DOCUMENT = 'SET_ACTIVITY_FEED_DOCUMENT';
export const SET_ACTIVITY_FEED_LINK_REQUEST = 'SET_ACTIVITY_FEED_LINK_REQUEST';
export const SET_ACTIVITY_FEED_INSTRUCTION = 'SET_ACTIVITY_FEED_INSTRUCTION';
export const GET_ACTIVITY_FEED_ACTIVITY_LIST = 'GET_ACTIVITY_FEED_ACTIVITY_LIST';
export const SET_ACTIVITY_FEED_LEFT_COUNT = 'SET_ACTIVITY_FEED_LEFT_COUNT';
export const RESET_ACTIVITY_FEED_LEFT_COUNT = 'RESET_ACTIVITY_FEED_LEFT_COUNT';

export const RESET_CREATE_PACKAGE_REQUEST_DETAILS = 'RESET_CREATE_PACKAGE_REQUEST_DETAILS';
//Setp 3
export const GET_ITEMS_TO_COPY = 'GET_ITEMS_TO_COPY';
export const SAVE_SELECTED_ITEMS_TO_COPY = 'SAVE_SELECTED_ITEMS_TO_COPY';
export const GET_SELECTED_ITEMS_TO_COPY = 'GET_SELECTED_ITEMS_TO_COPY';
export const REMOVE_SELECTED_ITEMS_TO_COPY = 'REMOVE_SELECTED_ITEMS_TO_COPY';
export const RESET_SELECTED_ITEMS_TO_COPY = 'RESET_SELECTED_ITEMS_TO_COPY';
export const CREATE_COPY_PACKAGE = 'CREATE_COPY_PACKAGE';
export const IMPORT_COPY_PACKAGE = 'IMPORT_COPY_PACKAGE';

export const DELETE_COPY_PACKAGE = 'DELETE_COPY_PACKAGE';

//#region ClientRequests
export const GET_CLIENT_REQUESTS = 'GET_CLIENT_REQUESTS';
export const GET_CLIENT_REQUESTS_PERSISTS_SELECTION = 'GET_CLIENT_REQUESTS_PERSISTS_SELECTION';
export const GET_CLIENT_REQUESTS_COMMENTS = 'GET_CLIENT_REQUESTS_COMMENTS';
export const CLEAN_CLIENT_REQUESTS_COMMENTS = 'CLEAN_CLIENT_REQUESTS_COMMENTS';
export const DELETE_CLIENT_REQUESTS_COMMENT = 'DELETE_CLIENT_REQUESTS_COMMENT';
export const SET_BULK_COMMON_CLIENT_REQUESTS_FILTERS = 'SET_BULK_COMMON_CLIENT_REQUESTS_FILTERS';
export const SET_COMMON_CLIENT_REQUESTS_FILTER = 'SET_COMMON_CLIENT_REQUESTS_FILTER';
export const SET_CLIENT_REQUESTS_FILTER = 'SET_CLIENT_REQUESTS_FILTER';
export const SET_CLIENT_REQUESTS_FILTERS_BULK = 'SET_CLIENT_REQUESTS_FILTERS_BULK';
export const CLEAR_CLIENT_REQUESTS_FILTERS = 'CLEAR_CLIENT_REQUESTS_FILTERS';
export const CLEAR_COMMON_CLIENT_REQUESTS_FILTERS = 'CLEAR_COMMON_CLIENT_REQUESTS_FILTERS';
export const GET_CLIENT_REQUESTS_CLIENT_GROUPS = 'GET_CLIENT_REQUESTS_CLIENT_GROUPS';
export const GET_CLIENT_REQUESTS_EXTERNAL_USERS = 'GET_CLIENT_REQUESTS_EXTERNAL_USERS';
export const SET_QUICK_FILTER = 'SET_QUICK_FILTER';
export const GET_CLIENT_REQUEST_BY_ID = 'GET_CLIENT_REQUEST_BY_ID';
export const CREATE_CLIENT_REQUEST_COMMENT = 'CREATE_CLIENT_REQUEST_COMMENT';
export const RETRY_COMMENT_SYNC = 'RETRY_COMMENT_SYNC';
export const GET_ASSOCIATED_CLIENT_REQUEST_DOCUMENTS = 'GET_ASSOCIATED_CLIENT_REQUEST_DOCUMENTS';
export const ASSOCIATE_EXISTING_DOCUMENT = 'ASSOCIATE_EXISTING_DOCUMENT';
export const DELETE_ASSOCIATED_DOCUMENT = 'DELETE_ASSOCIATED_DOCUMENT';
export const UPDATE_CLIENT_REQUEST = 'UPDATE_CLIENT_REQUEST';
export const SEND_CUSTOM_CLIENT_REQUEST = 'SEND_CUSTOM_CLIENT_REQUEST';
export const REFRESH_CLIENT_REQUEST_LIST = 'REFRESH_CLIENT_REQUEST_LIST';
export const PATCH_CLIENT_REQUEST_FIELDS = 'PATCH_CLIENT_REQUEST_FIELDS';
export const DELETE_CLIENT_REQUEST = 'DELETE_CLIENT_REQUEST';
export const PATCH_CLIENT_REQUEST_DUE_DATE = 'PATCH_CLIENT_REQUEST_DUE_DATE';
export const PATCH_CLIENT_REQUEST_PRIORITY_TYPE = 'PATCH_CLIENT_REQUEST_PRIORITY_TYPE';
export const UPDATE_REQUEST_DETAIL_DUE_DATE = 'UPDATE_REQUEST_DETAIL_DUE_DATE';
export const ADD_EY_CONTACT = 'ADD_EY_CONTACT';
export const DELETE_EY_CONTACT = 'DELETE_EY_CONTACT';
export const SET_SILENT_REFRESH_FLAG = 'SET_SILENT_REFRESH_FLAG';
export const RETURN_CLIENT_REQUEST = 'RETURN_CLIENT_REQUEST';
export const CREATE_CLIENT_REQUEST_RELATED_TASK = 'CREATE_CLIENT_REQUEST_RELATED_TASK';
export const DELETE_CLIENT_REQUEST_RELATED_TASK = 'DELETE_CLIENT_REQUEST_RELATED_TASK';
export const UPDATE_REQUEST_DETAIL_TIMEPHASE = 'UPDATE_REQUEST_DETAIL_TIMEPHASE';
export const GET_ALL_RELATED_TASKS_NEW_COLLAB = 'GET_ALL_RELATED_TASKS_NEW_COLLAB';
export const MY_PROGRESS_COLLABORATION_GET_REQUEST_STATS = 'MY_PROGRESS_COLLABORATION_GET_REQUEST_STATS';

export const SAVE_SORT_TABLE = 'SAVE_SORT_TABLE';
export const SAVE_SORT_TABLE_ALL = 'SAVE_SORT_TABLE_ALL';

export const SET_CREATE_COPY_SUCCESS_MESSAGE = 'SET_CREATE_COPY_SUCCESS_MESSAGE';
export const SET_COPY_ERROR_MESSAGE = 'SET_COPY_Error_MESSAGE';

export const GET_CLIENT_ACCESS_LOCATIONS = 'GET_CLIENT_ACCESS_LOCATIONS';
export const CREATE_CLIENT_ACCESS_LOCATIONS = 'CREATE_CLIENT_ACCESS_LOCATIONS';
export const CLEAN_CLIENT_ACCESS_LOCATIONS = 'CLEAN_CLIENT_ACCESS_LOCATIONS';
export const DELETE_ACCESS_LOCATION = 'DELETE_ACCESS_LOCATION';
export const IMPORT_ACCESS_LOCATIONS = 'IMPORT_ACCESS_LOCATIONS';
export const SET_ADVANCED_SEARCH_OPTIONS = 'SET_ADVANCED_SEARCH_OPTIONS';
export const RESET_ADVANCED_SEARCH_OPTIONS = 'RESET_ADVANCED_SEARCH_OPTIONS';
export const GET_FOLLOWERS_AND_RELATED_TASK = 'GET_FOLLOWERS_AND_RELATED_TASK';
export const COPY_TASK_DOCUMENTS_TO_ADD_DOCUMENTS = 'COPY_TASK_DOCUMENTS_TO_ADD_DOCUMENTS';
export const RELATE_DOCUMENT_TO_EXISTING_REQUEST = 'RELATE_DOCUMENT_TO_EXISTING_REQUEST';
export const UNRELATE_DOCUMENT_TO_EXISTING_REQUEST = 'UNRELATE_DOCUMENT_TO_EXISTING_REQUEST';
export const EXPORT_CLIENT_REQUESTS = 'EXPORT_CLIENT_REQUESTS';
export const GET_CLIENT_REQUESTS_SUMMARY = 'GET_CLIENT_REQUESTS_SUMMARY';

// Bulk Request Actions
export const BULK_REQUEST_ADD_REQUEST_TO_SELECTED_REQUESTS = 'BULK_REQUEST_ADD_REQUEST_TO_SELECTED_REQUESTS';
export const BULK_REQUEST_REMOVE_REQUEST_FROM_SELECTED_REQUESTS = 'BULK_REQUEST_REMOVE_REQUEST_FROM_SELECTED_REQUESTS';
export const BULK_REQUEST_REMOVE_ALL_REQUESTS_FROM_SELECTED_REQUESTS =
	'BULK_REQUEST_REMOVE_ALL_REQUESTS_FROM_SELECTED_REQUESTS';
export const BULK_REQUEST_ADD_ALL_REQUESTS_TO_SELECTED_REQUESTS = 'BULK_REQUEST_ADD_ALL_REQUESTS_TO_SELECTED_REQUESTS';
export const UPDATE_BULK_REQUEST_TASK_RELATIONS = 'UPDATE_BULK_REQUEST_TASK_RELATIONS';
export const CLEAR_BULK_CLIENT_REQUESTS_FROM_STORE = 'CLEAR_BULK_CLIENT_REQUESTS_FROM_STORE';
export const SET_BULK_CLIENT_REQUEST_FILTERS = 'SET_BULK_CLIENT_REQUEST_FILTERS';
export const SET_BULK_REQUEST_FILTER = 'SET_BULK_REQUEST_FILTER';
export const CLEAR_BULK_CLIENT_REQUEST_FILTERS = 'CLEAR_BULK_CLIENT_REQUEST_FILTERS';
export const SET_BULK_REQUEST_SEARCH = 'SET_BULK_REQUEST_SEARCH';
export const UPDATE_UNRELATED_REQUEST_COUNT_STORE = 'UPDATE_UNRELATED_REQUEST_COUNT_STORE';
export const SET_IS_REQUEST_LIST_UPDATE_REQUIRED = 'SET_IS_REQUEST_LIST_UPDATE_REQUIRED';

// Instructions
export const GET_CUSTOM_INSTRUCTION = 'GET_CUSTOM_INSTRUCTION';
export const CREATE_CUSTOM_INSTRUCTION = 'CREATE_CUSTOM_INSTRUCTION';
export const UPDATE_CUSTOM_INSTRUCTION = 'UPDATE_CUSTOM_INSTRUCTION';
export const CLEAN_CUSTOM_INSTRUCTION = 'CLEAN_CUSTOM_INSTRUCTION';

// Collaboration tag
export const GET_CLIENT_REQUEST_TAGS = 'GET_CLIENT_REQUEST_TAGS';
export const CLEAN_CLIENT_REQUEST_TAGS = 'CLEAN_CLIENT_REQUEST_TAGS';
export const CREATE_CLIENT_REQUEST_TAG = 'CREATE_CLIENT_REQUEST_TAG';
export const EDIT_CLIENT_REQUEST_TAG = 'EDIT_CLIENT_REQUEST_TAG';
export const DELETE_CLIENT_REQUEST_TAG = 'DELETE_CLIENT_REQUEST_TAG';
export const ASSOCIATE_CLIENT_REQUEST_TAG = 'ASSOCIATE_CLIENT_REQUEST_TAG';
export const UNASSOCIATE_CLIENT_REQUEST_TAG = 'UNASSOCIATE_CLIENT_REQUEST_TAG';

// Colaboration page
export const GET_CLIENT_ENGAGEMENT_NAME = 'GET_CLIENT_ENGAGEMENT_NAME';
export const UPDATE_CLIENT_ENGAGEMENT_NAME = 'UPDATE_CLIENT_ENGAGEMENT_NAME';
export const CLEAN_CLIENT_ENGAGEMENT_NAME = 'CLEAN_CLIENT_ENGAGEMENT_NAME';

// Collaboration Filter (My, All)
export const SAVE_REQUEST_FILTERS = 'SAVE_REQUEST_FILTERS';
export const GET_EP_EQR_TASKS_SIGN_OFF_COUNT = 'GET_EP_EQR_TASKS_SIGN_OFF_COUNT';
export const CLEAR_EP_EQR_TASKS_SIGN_OFF_COUNT = 'CLEAR_EP_EQR_TASKS_SIGN_OFF_COUNT';
export const GET_OVERSIGHT_PROJECT_BY_PROJECTID = 'GET_OVERSIGHT_PROJECT_BY_PROJECTID';
export const GET_OVERSIGHT_OTHER_PROJECTS_BY_ENGAGEMENT = 'GET_OVERSIGHT_OTHER_PROJECTS_BY_ENGAGEMENT';

/* Assigned To */
export const REASSIGN_REQUEST = 'REASSIGN_REQUEST';
export const UPDATE_IS_VALID_ASSIGNTO = 'UPDATE_IS_VALID_ASSIGNTO';
export const UPDATE_SHOW_ASSIGNED_TO_EMPTY_ERROR = 'UPDATE_SHOW_ASSIGNED_TO_EMPTY_ERROR';

export const REASSIGN_REQUEST_BULK = 'REASSIGN_REQUEST_BULK';
/* Update Client Request Detail */
export const UPDATE_CLIENT_REQUEST_DETAIL = 'UPDATE_CLIENT_REQUEST_DETAIL';

// GAScopes
export const GET_GA_SCOPES = 'GET_GA_SCOPES';
export const GET_GA_ASSIGNED_SCOPES = 'GET_GA_ASSIGNED_SCOPES';
export const ADD_GA_SUB_SCOPE = 'ADD_GA_SUB_SCOPE';
export const MODIFY_GA_SUB_SCOPE = 'MODIFY_GA_SUB_SCOPE';
export const REMOVE_GA_SUB_SCOPE = 'REMOVE_GA_SUB_SCOPE';
export const RESET_GA_SUB_SCOPES = 'RESET_GA_SUB_SCOPES';
// GS Scopes send link request
export const GET_GS_SCOPE_LINK_REQUEST = 'GET_GS_SCOPE_LINK_REQUEST';
export const CHANGE_GS_TEAM = 'CHANGE_GS_TEAM';
export const CHANGE_GS_SCOPE = 'CHANGE_GS_SCOPE';
export const POST_GS_SCOPE_LINK_REQUEST = 'POST_GS_SCOPE_LINK_REQUEST';

// GS Scopes send version
export const GET_GS_SCOPE_SEND_VERSION = 'GET_GS_SCOPE_SEND_VERSION';
export const CHANGE_GS_SV_TEAM = 'CHANGE_GS_SV_TEAM';
export const CHANGE_GS_SV_SCOPE = 'CHANGE_GS_SV_SCOPE';
export const POST_GS_SCOPE_SEND_VERSION = 'POST_GS_SCOPE_SEND_VERSION';

// Scopes for Group Summary page (GS Scopes)
export const GET_GS_SCOPES = 'GET_GS_SCOPES';
export const GET_GS_TEAMS_DATA = 'GET_GS_TEAMS_DATA';
export const GET_GS_INSTRUCTIONS_DATA = 'GET_GS_INSTRUCTIONS_DATA';
export const GET_GS_TASKS_DATA = 'GET_GS_TASKS_DATA';
export const RESET_GS_TAB_DATA = 'RESET_GS_TAB_DATA';
// GS SnapShots action types
export const GET_PUBLISHED_VERSION_OPTIONS = 'GET_PUBLISHED_VERSION_OPTIONS';
export const GET_SENT_VERSION_OPTIONS = 'GET_SENT_VERSION_OPTIONS';
export const GET_PUBLISHED_VERSION_SNAPSHOT = 'GET_PUBLISHED_VERSION_SNAPSHOT';
export const GET_SENT_VERSION_SNAPSHOT = 'GET_SENT_VERSION_SNAPSHOT';
// ReceiveInstructions action types
export const GET_RECEIVED_INSTRUCTIONS = 'GET_RECEIVED_INSTRUCTIONS';
export const PUT_RECEIVED_INSTRUCTIONS = 'PUT_RECEIVED_INSTRUCTIONS';
export const GET_EARLIER_SNAPSHOT = 'GET_EARLIER_SNAPSHOT';
export const RESET_EARLIER_SNAPSHOT = 'RESET_EARLIER_SNAPSHOT';
export const GET_GROUP_VERSIONS_RECEIVED_INSTRUCTIONS = 'GET_GROUP_VERSIONS_RECEIVED_INSTRUCTIONS';
export const GET_GROUP_DOCUMENTS_INSTRUCTIONS = 'GET_GROUP_DOCUMENTS_INSTRUCTIONS';
/*Sending Client Request*/
export const SEND_CLIENT_REQUEST = 'SEND_CLIENT_REQUEST';
export const SET_TOAST_MESSAGE_FLAG = 'SET_TOAST_MESSAGE_FLAG';

// GAComponents
export const GET_GA_TEAMS = 'GET_GA_TEAMS';
export const GET_MS_PHOTO = 'GET_MS_PHOTO';
export const SET_PHOTO = 'SET_PHOTO';
export const SET_PHOTO_HTML = 'SET_PHOTO_HTML';
export const ADD_GA_TEAM = 'ADD_GA_TEAM';
export const DELETE_GA_TEAM = 'DELETE_GA_TEAM';
export const EDIT_GA_TEAM = 'EDIT_GA_TEAM';
export const RESET_GA_TEAMS = 'RESET_GA_TEAMS';
export const GET_LINK_REQUEST_GA_TEAMS = 'GET_LINK_REQUEST_GA_TEAMS';
export const CHANGE_GA_TEAM_LINK_REQUEST = 'CHANGE_GA_TEAM_LINK_REQUEST';
export const CHANGE_GA_SCOPE_LINK_REQUEST = 'CHANGE_GA_SCOPE_LINK_REQUEST';
export const SET_TEAM_LINK_STATUS_LOADING = 'SET_TEAM_LINK_STATUS_LOADING';

//GroupInstructions
export const GET_GROUP_COMPONENTS_BY_COMPONENTID = 'GET_GROUP_COMPONENTS_BY_COMPONENTID';

// GAInstructions
export const GET_GA_INSTRUCTIONS = 'GET_GA_INSTRUCTIONS';
export const CREATE_GA_INSTRUCTIONS = 'CREATE_GA_INSTRUCTIONS';
export const EDIT_GA_INSTRUCTIONS = 'EDIT_GA_INSTRUCTIONS';
export const DELETE_GA_INSTRUCTIONS = 'DELETE_GA_INSTRUCTIONS';
export const CREATE_PUBLISH_CHANGES = 'CREATE_PUBLISH_CHANGES';
export const SET_LATEST_PUBLISH = 'SET_LATEST_PUBLISH';
export const UPDATE_DOCUMENT_NAME_ON_INSTRUCTIONS = 'UPDATE_DOCUMENT_NAME_ON_INSTRUCTIONS';
export const DELETE_DOCUMENT_ON_INSTRUCTIONS = 'DELETE_DOCUMENT_ON_INSTRUCTIONS';

// GAInstruction Sections
export const CREATE_GA_SECTION = 'CREATE_GA_SECTION';
export const EDIT_GA_SECTION = 'EDIT_GA_SECTION';
export const DELETE_GA_SECTION = 'DELETE_GA_SECTION';

// GATasks
export const GET_GA_TASKS = 'GET_GA_TASKS';
export const CREATE_GA_TASK = 'CREATE_GA_TASK';
export const EDIT_GA_TASK = 'EDIT_GA_TASK';
export const DELETE_GA_TASK = 'DELETE_GA_TASK';
export const UPDATE_DOCUMENT_NAME_ON_TASKS = 'UPDATE_DOCUMENT_NAME_ON_TASKS';
export const DELETE_DOCUMENT_ON_TASKS = 'DELETE_DOCUMENT_ON_TASKS';

export const MARK_AS_DELETED_DOCUMENT = 'MARK_AS_DELETED_DOCUMENT';
export const GET_AUTOMATIONS = 'GET_AUTOMATIONS';

// CGT Send
export const GET_CANVAS_FORM_VALIDATION = 'GET_CANVAS_FORM_VALIDATION';

export const GET_ENGAGEMENT_ACTIVITY = 'GET_ENGAGEMENT_ACTIVITY';
export const GET_ENTITY_ACTIVITY = 'GET_ENTITY_ACTIVITY';
export const GET_CATEGORY_NEXT_PAGE = 'GET_CATEGORY_NEXT_PAGE';
export const CHANGE_PAGE_CATEGORY_PAGE_SIZE = 'CHANGE_PAGE_CATEGORY_PAGE_SIZE';

// Ey Contact
export const GET_EY_CONTACTS = 'GET_EY_CONTACTS';

// Related tasks
export const CLEAN_GET_ALL_TASKS = 'CLEAN_GET_ALL_TASKS';

export const SET_ENTITY_CHECKED = 'SET_ENTITY_CHECKED';
export const SET_WHOLE_ENTITY_CHECKED = 'SET_WHOLE_ENTITY_CHECKED';

export const GET_ENGAGEMENT_IPFILTERSTATUS = 'GET_ENGAGEMENT_IPFILTERSTATUS';

// Toasts - bulk assignmets modal
export const ADD_BULK_ASSIGNMENTS_TOAST = 'ADD_BULK_ASSIGNMENTS_TOAST';
export const REMOVE_BULK_ASSIGNMENTS_TOAST = 'REMOVE_BULK_ASSIGNMENTS_TOAST';

// Tasklist - bulk markcomplete
export const GET_MARK_COMPLETE_TASKS = 'GET_MARK_COMPLETE_TASKS';
export const CLEAR_MARK_COMPLETE_TASKS = 'CLEAR_MARK_COMPLETE_TASKS';

// Tasklist - bulk handoff
export const GET_HAND_OFF_TASKS = 'GET_HAND_OFF_TASKS';
export const CLEAR_HAND_OFF_TASKS = 'CLEAR_HAND_OFF_TASKS';

export const GET_SAVED_FILTERS = 'GET_SAVED_FILTERS';
export const SAVE_FILTERS = 'SAVE_FILTERS';
export const UPDATE_FILTERS = 'UPDATE_FILTERS';
export const DELETE_FILTERS = 'DELETE_FILTERS';

export const UPDATE_TASKLIST_ON_DELETE_ASSIGNMENT = 'UPDATE_TASKLIST_ON_DELETE_ASSIGNMENT';
export const UPDATE_TASKLIST_ON_CREATE_ASSIGNMENT = 'UPDATE_TASKLIST_ON_CREATE_ASSIGNMENT';
export const DELETE_TASK_ON_REPLACE = 'DELETE_TASK_ON_REPLACE';
export const DELETE_TASK_ON_REMOVE = 'DELETE_TASK_ON_REMOVE';

// Build steps v2
export const GET_TASKS_WITH_BUILD_MILESTONE_ID = 'GET_TASKS_WITH_BUILD_MILESTONE_ID';
export const GET_GUIDANCE_LINKS_FOR_SUPER_MODAL = 'GET_GUIDANCE_LINKS_FOR_SUPER_MODAL';
export const GET_TASK_DETAILS_FOR_SUPER_MODAL = 'GET_TASK_DETAILS_FOR_SUPER_MODAL';
export const SET_SUPER_MODAL_QL = 'SET_SUPER_MODAL_QL';
export const SET_SUPER_MODAL_OPEN = 'SET_SUPER_MODAL_OPEN';

// Dashboard v2 - PIC EQR Dashboard
export const SET_DASHBOARD_COMMON_STATE = 'SET_DASHBOARD_COMMON_STATE';
export const GET_ALL_TASKS_EXECUTIVE_DASHBOARD = 'GET_ALL_TASKS_EXECUTIVE_DASHBOARD';
export const RESET_RELOAD_DATA_FLAG_FOR_PIC_EQR_DASHBOARD = 'RESET_RELOAD_DATA_FLAG_FOR_PIC_EQR_DASHBOARD';
export const START_LISTENING_TO_CHANGES_ON_TASK_DRAWER = 'START_LISTENING_TO_CHANGES_ON_TASK_DRAWER';
export const STOP_LISTENING_TO_CHANGES_ON_TASK_DRAWER = 'STOP_LISTENING_TO_CHANGES_ON_TASK_DRAWER';

//General toast message
export const SET_GENERAL_TOAST_MESSAGE = 'SET_GENERAL_TOAST_MESSAGE';
export const CLEAR_GENERAL_TOAST_MESSAGE = 'CLEAR_GENERAL_TOAST_MESSAGE';

//Set boolean value once current resouce is available w.r.t user setting
export const SET_IS_CURRENT_RESOURCE_AVAILABLE = 'SET_IS_CURRENT_RESOURCE_AVAILABLE';

//PSP Indexes
export const GET_AVAILABLE_PSP_INDEXES = 'GET_AVAILABLE_PSP_INDEXES';

export const REMOVE_CUSTOM_FILTER = 'REMOVE_CUSTOM_FILTER';

// Task related documents
export const GET_RELATED_DOCUMENTS = 'GET_RELATED_DOCUMENTS';
export const CLEAR_RELATED_DOCUMENTS = 'CLEAR_RELATED_DOCUMENTS';

// MultiEntity Dashboard
export const GET_TASK_OVERVIEW_COUNT = 'GET_TASK_OVERVIEW_COUNT';
export const RESET_TASK_OVERVIEW_COUNT = 'RESET_TASK_OVERVIEW_COUNT';

//Trial balance
export const GET_TRIAL_BALANCE = 'GET_TRIAL_BALANCE';
export const GET_TRIAL_BALANCE_BY_ID = 'GET_TRIAL_BALANCE_BY_ID';
export const MODIFY_GLACCOUNT_DOCUMENT = 'MODIFY_GLACCOUNT_DOCUMENT';
export const GET_GL_ACCOUNTS = 'GET_GL_ACCOUNTS';
export const GET_GL_ACCOUNT_BY_ID = 'GET_GL_ACCOUNT_BY_ID';
export const GET_ADJUSTED_TRIAL_BALANCE_BY_ID = 'GET_ADJUSTED_TRIAL_BALANCE_BY_ID';
export const GET_FINANCIALSTATEMENT_BY_ID = 'GET_FINANCIALSTATEMENT_BY_ID';
export const CLEAR_FINANCIALSTATEMENT_BY_ID = 'CLEAR_FINANCIALSTATEMENT_BY_ID';
export const UPDATE_FINANCIALSTATEMENT_BY_ID = 'UPDATE_FINANCIALSTATEMENT_BY_ID';
export const CLEAR_TRIAL_BALANCE_DATA = 'CLEAR_TRIAL_BALANCE_DATA';
export const POST_TRIAL_BALANCE_DATA = 'POST_TRIAL_BALANCE_DATA';
export const DELETE_TRIAL_BALANCE = 'DELETE_TRIAL_BALANCE';
export const PATCH_TRIAL_BALANCE = 'PATCH_TRIAL_BALANCE';
export const PUT_TRIAL_BALANCE = 'PUT_TRIAL_BALANCE';
export const SET_FINANCIAL_STATEMENT_MULTIPLE_MENU_FILTER = 'SET_FINANCIAL_STATEMENT_MULTIPLE_MENU_FILTER';
export const CLEAR_FINANCIAL_STATEMENT_MENU_FILTERS = 'CLEAR_FINANCIAL_STATEMENT_MENU_FILTERS';

export const ADD_GL_ACCOUNT = 'ADD_GL_ACCOUNT';
export const UPDATE_GL_ACCOUNT = 'UPDATE_GL_ACCOUNT';
export const DELETE_GL_ACCOUNT = 'DELETE_GL_ACCOUNT';

export const RESET_LEVEL2_TASK_OVERVIEW_COUNT = 'RESET_LEVEL2_TASK_OVERVIEW_COUNT';
export const GET_LEVEL2_COUNTS = 'GET_LEVEL2_COUNTS';
export const GET_ALL_SCOTS = 'GET_ALL_SCOTS';
export const GET_SCOT_BY_ID = 'GET_SCOT_BY_ID';
export const UPDATE_SCOT = 'UPDATE_SCOT';
export const CREATE_SCOT = 'CREATE_SCOT';
export const CLEAR_SCOT = 'CLEAR_SCOT';
export const GET_ALL_UNASSIGNED_COUNT = 'GET_ALL_UNASSIGNED_COUNT';
export const GET_ALL_UNRELATED_REQUESTS_COUNT = 'GET_ALL_UNRELATED_REQUESTS_COUNT';
export const DELETE_SCOT_BY_ID = 'DELETE_SCOT_BY_ID';
export const UNRELATING_ACCOUNT_FROM_SCOT = 'UNRELATING_ACCOUNT_FROM_SCOT';
export const LINK_SCOT_RELATE_TASK = 'LINK_SCOT_RELATE_TASK';
export const UNLINK_SCOT_RELATE_TASK = 'UNLINK_SCOT_RELATE_TASK';
export const ADD_SCOT_RELATED_TASK = 'ADD_SCOT_RELATED_TASK';

// Estimates
export const GET_ESTIMATES = 'GET_ESTIMATES';
export const DELETE_ESTIMATE = 'DELETE_ESTIMATE';

// STEntities
export const ALL_STENTITIES = 'ALL_STENTITIES';
export const DELETE_STENTITY = 'DELETE_STENTITY';
export const CREATE_STENTITY = 'CREATE_STENTITY';
export const UPDATE_ENTITY_DOCUMENT_RELATE = 'UPDATE_ENTITY_DOCUMENT_RELATE';
export const DELETE_ENTITY_DOCUMENT_RELATE = 'DELETE_ENTITY_DOCUMENT_RELATE';
export const ALL_STENTITIES_FOR_TASK = 'ALL_STENTITIES_FOR_TASK';

// Controls
export const GET_ALL_CONTROLS = 'GET_ALL_CONTROLS';
export const GET_ALL_ORPHANED_CONTROLS = 'GET_ALL_ORPHANED_CONTROLS';
export const GET_CONTROL_BY_ID = 'GET_CONTROL_BY_ID';
export const DELETE_CONTROL_BY_ID = 'DELETE_CONTROL_BY_ID';
export const DELETE_ORPHAN_CONTROL_BY_ID = 'DELETE_ORPHAN_CONTROL_BY_ID';
export const GET_UNRELATED_CONTROLS_COUNT = 'GET_UNRELATED_CONTROLS_COUNT';
export const UNRELATE_CONTROL_FROM_WCGW = 'UNRELATE_CONTROL_FROM_WCGW';
export const LINK_CONTROL_TO_WCGW = 'LINK_CONTROL_TO_WCGW';
export const CLEAR_CONTROL = 'CLEAR_CONTROL';
export const CLEAR_FILTERED_CONTROLS = 'CLEAR_FILTERED_CONTROLS';
export const CREATE_CONTROL = 'CREATE_CONTROL';
export const UPDATE_CONTROL = 'UPDATE_CONTROL';
export const ADD_CONTROL_RELATED_TASK = 'ADD_CONTROL_RELATED_TASK';
export const PATCH_CONTROL = 'PATCH_CONTROL';
export const GET_CONTROLS_WITH_NO_DESIGN_EFFECTIVENESS_COUNT = 'GET_CONTROLS_WITH_NO_DESIGN_EFFECTIVENESS_COUNT';
export const GET_FILTERED_CONTROLS = 'GET_FILTERED_CONTROLS';

// IT Applications
export const GET_ALL_IT_APPS = 'GET_ALL_IT_APPS';
export const GET_IT_APP_BY_ID = 'GET_IT_APP_BY_ID';
export const DELETE_IT_APPS_BY_ID = 'DELETE_IT_APPS_BY_ID';
export const CREATE_IT_APP = 'CREATE_IT_APP';
export const UPDATE_IT_APPS_BY_ID = 'UPDATE_IT_APPS_BY_ID';
export const UNRELATE_ITSOAPP_FROM_SCOT = 'UNRELATE_ITSOAPP_FROM_SCOT';
export const CLEAR_IT_APPLICATION = 'CLEAR_IT_APPLICATION';

//IT Controls
export const GET_ALL_ITCONTROLS = 'GET_ALL_ITCONTROLS';
export const GET_UNRELATED_ITCONTROLS_COUNT = 'GET_UNRELATED_ITCONTROLS_COUNT';
export const ADD_ITCONTROL_RELATED_TASK = 'ADD_ITCONTROL_RELATED_TASK';
export const REMOVE_ITCONTROL_RELATED_TASK = 'REMOVE_ITCONTROL_RELATED_TASK';
export const RELATING_ITCONTROLS_RELATE_TASK = 'RELATING_ITCONTROLS_RELATE_TASK';
export const UNRELATING_ITCONTROLS_RELATE_TASK = 'UNRELATING_ITCONTROLS_RELATE_TASK';

export const GET_KNOWLEDGE_INDUSTRIES = 'GET_KNOWLEDGE_INDUSTRIES';
export const GET_KNOWLEDGE_ACCOUNTS = 'GET_KNOWLEDGE_ACCOUNTS';
export const DISABLE_IMPORT_BUTTON = 'DISABLE_IMPORT_BUTTON';
export const SET_SELECTED_INDUSTRY = 'SET_SELECTED_INDUSTRY';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_SHOW_ONLY_SELECTED = 'SET_SHOW_ONLY_SELECTED';
export const SET_SELECTED_ACCOUNTS = 'SET_SELECTED_ACCOUNTS';
export const POST_KNOWLEDGE_ACCOUNT = 'POST_KNOWLEDGE_ACCOUNT';
export const SET_SELECTED_SCOT = 'SET_SELECTED_SCOT';
export const RESET_SELECTED_KNOWLEDGE_ENTITY_OBJECT = 'RESET_SELECTED_KNOWLEDGE_ENTITY_OBJECT';
export const RESET_SELECTED_INDUSTRY = 'RESET_SELECTED_INDUSTRY';
export const RESET_SELECTED_SCOT = 'RESET_SELECTED_SCOT';

// WCGW
export const ADD_WCGW = 'ADD_WCGW';
export const ADD_SCOT_WCGW_RELATION = 'ADD_SCOT_WCGW_RELATION';
export const UPDATE_WCGW = 'UPDATE_WCGW';
export const UPDATE_SCOT_WCGW_RELATION = 'UPDATE_SCOT_WCGW_RELATION';
export const CLEAR_WCGW = 'CLEAR_WCGW';
export const GET_WCGW_BY_ID = 'GET_WCGW_BY_ID';
export const DELETE_WCGW_BY_ID = 'DELETE_WCGW_BY_ID';

// Knowledge Entity
export const GET_KNOWLEDGE_ENTITY_DATA = 'GET_KNOWLEDGE_ENTITY_DATA';
export const POST_KNOWLEDGE_SCOT = 'POST_KNOWLEDGE_SCOT';
export const POST_KNOWLEDGE_OSP = 'POST_KNOWLEDGE_OSP';
export const POST_KNOWLEDGE_WCGW = 'POST_KNOWLEDGE_WCGW';
export const POST_KNOWLEDGE_CONTROL = 'POST_KNOWLEDGE_CONTROL';

//#region Federated Modules
export const SET_USER_PREFERENCES_FEDERATED_MODULE = 'SET_USER_PREFERENCES_FEDERATED_MODULE';
export const CREATE_ANALYTIC_DOCUMENT = 'CREATE_ANALYTIC_DOCUMENT';
//#endregion

export const GET_ENGAGEMENT_MAP = 'GET_ENGAGEMENT_MAP';
export const TRIGGER_ENGAGEMENT_MAP_UPDATE = 'TRIGGER_ENGAGEMENT_MAP_UPDATE';
export const CLEAR_ENGAGEMENT_MAP = 'CLEAR_ENGAGEMENT_MAP';

export const SET_TOASTER_VISIBILITY = 'SET_TOASTER_VISIBILITY';
// GL Accounts notes
export const GET_ALL_GL_ACCOUNT_NOTES = 'GET_ALL_GL_ACCOUNT_NOTES';
export const ASSOCIATE_GL_ACCOUNT_NOTE = 'ASSOCIATE_GL_ACCOUNT_NOTE';
export const GET_GL_ACCOUNT_NOTES = 'GET_GL_ACCOUNT_NOTES';

export const ADD_TICKMARKS = 'ADD_TICKMARKS';
export const REMOVE_TICKMARKS = 'REMOVE_TICKMARKS';

// EYQ actions
export const SET_AICHATBOT_INTEGRATION_PARAMETERS = 'SET_AICHATBOT_INTEGRATION_PARAMETERS';
export const GET_AICHATBOT_INTEGRATION_PARAMETERS = 'GET_AICHATBOT_INTEGRATION_PARAMETERS';

export const UPDATE_GLOBAL_NAV_ACTIVE_ICON = 'UPDATE_GLOBAL_NAV_ACTIVE_ICON';

export const BENEFIT_SERVICE_INTEGRATION = 'BENEFIT_SERVICE_INTEGRATION ';
